export const INVENTORY_EN = {
    "inventory.uom.piece": "Piece",
    "inventory.uom.box": "Box",
    "inventory.uom.pack": "Pack",
    "inventory.uom.set": "Set",
    "inventory.uom.pair": "Pair",
    "inventory.uom.roll": "Roll",
    "inventory.uom.sheet": "Sheet",
    "inventory.uom.kg": "Kilogram",
    "inventory.uom.g": "Gram",
    "inventory.uom.litre": "Litre",
    "inventory.uom.ml": "Millilitre",
    "inventory.uom.metre": "Metre",
    "inventory.uom.cm": "Centimetre",
    "inventory.uom.sq_metre": "Square metre",
    "inventory.uom.cubic_metre": "Cubic metre",
    "inventory.uom.hour": "Hour",
    "inventory.kind.receipt": "Receipt",
    "inventory.kind.issue": "Issue",
    "inventory.kind.return": "Return",
    "inventory.kind.adjustment": "Adjustment",
    "inventory.kind.reversal": "Reversal",
    "inventory.reason.count": "Stock count",
    "inventory.reason.damage": "Damaged",
    "inventory.reason.loss": "Lost",
    "inventory.reason.found": "Found",
    "inventory.reason.opening": "Opening stock",
    "inventory.reason.expiry": "Expired",
    "inventory.reason.other": "Other",
    "inventory.status.active": "In use",
    "inventory.status.retired": "Retired",
    "inventory.col.name_ar": "Item",
    "inventory.col.code": "Code",
    "inventory.col.on_hand": "In stock",
    "inventory.col.uom": "Unit",
    "inventory.col.stock_value": "Stock value",
    "inventory.col.status": "Status",
    "inventory.col.name_en": "Name in English",
    "inventory.col.default_cost": "Default cost",
    "inventory.col.id": "Id",
    "inventory.col.version": "Version",
    "inventory.col.can_edit": "Can be edited",
    "inventory.col.can_retire": "Can be retired",
    "inventory.col.can_reactivate": "Can be reactivated",
    "inventory.field.store_id": "Store",
    "inventory.field.quantity": "Quantity",
    "inventory.field.unit_cost": "Cost of one unit",
    "inventory.field.unit_cost.help": "Empty: the item's default cost.",
    "inventory.field.party_id": "Received from",
    "inventory.field.note": "Note",
    "inventory.action.receive": "Receive",
    "inventory.field.ref_label": "Issued for",
    "inventory.field.ref_label.help": "What the stock is taken out for.",
    "inventory.action.issue": "Issue",
    "inventory.field.delta": "Change",
    "inventory.field.delta.help": "Positive adds to the store, negative takes from it.",
    "inventory.field.added_cost": "Cost of one unit",
    "inventory.field.added_cost.help": "Only for stock added. Empty: the average cost.",
    "inventory.field.reason": "Reason",
    "inventory.action.adjust": "Adjust",
    "inventory.field.name_ar": "Name in Arabic",
    "inventory.field.name_en": "Name in English",
    "inventory.field.uom": "Counted in",
    "inventory.field.uom.help": "Fixed once stock has moved.",
    "inventory.field.default_cost": "Default cost",
    "inventory.field.default_cost.help": "What one unit is received at when no cost is given.",
    "inventory.action.edit": "Edit",
    "inventory.action.retire": "Retire item",
    "inventory.action.reactivate": "Reactivate",
    "inventory.items.title": "Items",
    "inventory.items.lede": "What the workspace keeps in its stores, with what is in stock and what it cost.",
    "inventory.stat.out_of_stock": "Out of stock",
    "inventory.items.empty": "No item yet. Add the first thing the workspace keeps in stock.",
    "inventory.field.code": "Code",
    "inventory.field.code.help": "What people type and print. Letters, digits, . _ -; it does not change.",
    "inventory.action.create": "New item",
    "inventory.col.store_name_ar": "Store",
    "inventory.col.held": "In stock",
    "inventory.col.average_cost": "Average cost",
    "inventory.col.held_value": "Stock value",
    "inventory.col.store_id": "Store id",
    "inventory.item.title": "Item",
    "inventory.col.store_count": "Stores holding it",
    "inventory.col.created_at": "Added",
    "inventory.col.retired_at": "Retired",
    "inventory.item.table.balances": "By store",
    "inventory.item.table.balances.note": "The average cost is what the store holds divided by its quantity; it changes with every receipt.",
    "inventory.item.tab.moves": "Moves",
    "inventory.item.monogram": "It",
    "inventory.item_moves.title": "Moves",
    "inventory.col.posted_at": "Posted",
    "inventory.col.kind": "Move",
    "inventory.col.quantity": "Quantity",
    "inventory.col.value": "Value",
    "inventory.col.ref_label": "For",
    "inventory.col.item_id": "Item id",
    "inventory.moves.card.empty": "Nothing has moved yet.",
    "inventory.col.item_name_ar": "Item",
    "inventory.store_moves.title": "Moves",
    "inventory.action.edit_store": "Edit",
    "inventory.action.retire_store": "Retire store",
    "inventory.action.reactivate_store": "Reactivate",
    "inventory.stores.title": "Stores",
    "inventory.stores.lede": "Where stock is kept; a store is retired once it holds nothing.",
    "inventory.stores.empty": "No store yet. Add the first place stock is kept.",
    "inventory.col.store_name": "Store",
    "inventory.col.item_count": "Items held",
    "inventory.col.scope_ref": "Belongs to",
    "inventory.action.create_store": "New store",
    "inventory.store.title": "Store",
    "inventory.store.table.balances": "What it holds",
    "inventory.store.monogram": "St",
    "inventory.moves.title": "Stock moves",
    "inventory.moves.lede": "Every receipt, issue, return and adjustment, as posted; a mistake is corrected by reversing it.",
    "inventory.moves.empty": "Nothing has moved yet. Receive stock to start.",
    "inventory.col.party_name": "Received from",
    "inventory.col.unit_cost": "Cost of one unit",
    "inventory.col.balance_quantity": "In stock after",
    "inventory.col.reason": "Reason",
    "inventory.col.note": "Note",
    "inventory.col.returnable": "Still out",
    "inventory.col.party_id": "Party id",
    "inventory.col.ref_entity": "Document type",
    "inventory.col.ref_id": "Document",
    "inventory.col.reversed": "Reversed",
    "inventory.col.can_return": "Can be returned",
    "inventory.col.can_reverse": "Can be reversed",
    "inventory.field.item_id": "Item",
    "inventory.action.receive_any": "Receive stock",
    "inventory.action.issue_any": "Issue stock",
    "inventory.action.adjust_any": "Adjust stock",
    "inventory.field.return_quantity": "Quantity back",
    "inventory.field.return_quantity.help": "At most what is still out.",
    "inventory.action.return": "Take back",
    "inventory.field.reverse_reason": "Why it is reversed",
    "inventory.field.reverse_reason.help": "The move stays on record; its opposite is posted beside it.",
    "inventory.action.reverse": "Reverse",
    "nav.module.inventory": "Inventory",
    "nav.inventory.items": "Items",
    "nav.inventory.moves": "Stock moves",
    "nav.inventory.stores": "Stores",
    "screen.inventory.items.title": "Items",
    "screen.inventory.item.title": "Item",
    "screen.inventory.stores.title": "Stores",
    "screen.inventory.store.title": "Store",
    "screen.inventory.moves.title": "Stock moves",
    "entity.inventory.item": "Item",
    "entity.inventory.store": "Store",
    "inventory.refusal.active": "This is in use already.",
    "inventory.refusal.code": "A code is letters, digits, . _ and -, up to 40.",
    "inventory.refusal.code_required": "Give a code.",
    "inventory.refusal.code_fixed": "A code does not change; retire this and add another.",
    "inventory.refusal.code_taken": "This code is taken in this workspace.",
    "inventory.refusal.consumed_at_other_cost": "What this move brought in has since gone out at another cost; correct it with an adjustment.",
    "inventory.refusal.cost": "A cost is an amount, four decimals at most, not negative.",
    "inventory.refusal.cost_on_decrease": "Stock taken out leaves at its average cost; give no cost.",
    "inventory.refusal.delta": "Give a change other than zero: positive adds, negative takes away.",
    "inventory.refusal.has_returns": "Part of this issue came back; reverse its returns first.",
    "inventory.refusal.holds_stock": "This item is still in stock ({on_hand}); issue or adjust it to zero first.",
    "inventory.refusal.item_not_found": "No such item.",
    "inventory.refusal.item_retired": "This item is retired; reactivate it first.",
    "inventory.refusal.item_id": "Choose an item.",
    "inventory.refusal.item_id_required": "Choose an item.",
    "inventory.refusal.key_required": "A move against a document is sent with a repeat-protection key, so a retry never moves stock twice.",
    "inventory.refusal.limit": "The limit is a whole number from 1 to 500.",
    "inventory.refusal.move_not_found": "No such move.",
    "inventory.refusal.not_issue": "Only an issue is taken back.",
    "inventory.refusal.not_text": "This must be text.",
    "inventory.refusal.note_required": "Say what the adjustment is for.",
    "inventory.refusal.over_return": "Only {available} of this issue is still out.",
    "inventory.refusal.party": "No such party among those you may see.",
    "inventory.refusal.party_id": "Choose a party.",
    "inventory.refusal.quantity": "A quantity is a number above zero, three decimals at most.",
    "inventory.refusal.quantity_required": "Give a quantity.",
    "inventory.refusal.ref": "A document is named by its type and its id together.",
    "inventory.refusal.ref_entity": "The document type is written module.entity.",
    "inventory.refusal.ref_id": "The document id is letters, digits, _ . : and -.",
    "inventory.refusal.ref_label_required": "Say what the stock is issued for.",
    "inventory.refusal.retired": "This is retired.",
    "inventory.refusal.reverse_reversal": "A reversal is not reversed; post the move again.",
    "inventory.refusal.reversed": "This move was reversed.",
    "inventory.refusal.short": "Only {available} is in this store.",
    "inventory.refusal.stale": "This changed since you opened it. Reload and try again.",
    "inventory.refusal.status": "Choose in use or retired.",
    "inventory.refusal.status_route": "It is retired or reactivated through its own action.",
    "inventory.refusal.store_holds_stock": "{items} items are still held in this store; move them out first.",
    "inventory.refusal.store_not_found": "No such store.",
    "inventory.refusal.store_retired": "This store is retired; reactivate it first.",
    "inventory.refusal.store_id": "Choose a store.",
    "inventory.refusal.store_id_required": "Choose a store.",
    "inventory.refusal.too_long": "This is longer than {max} characters.",
    "inventory.refusal.unit_cost_required": "Give the cost of one unit: this item has no default cost.",
    "inventory.refusal.uom": "Choose a unit from the list.",
    "inventory.refusal.uom_required": "Choose the unit it is counted in.",
    "inventory.refusal.uom_fixed": "Stock of this item has moved; its unit no longer changes.",
    "inventory.refusal.version": "The version is the whole number the record was read at.",
    "inventory.refusal.name_ar_required": "Give the name in Arabic.",
    "inventory.refusal.reason": "Choose a reason from the list.",
    "inventory.refusal.reason_required": "Give the reason.",
    "inventory.refusal.kind": "Choose a kind of move from the list.",
    "inventory.refusal.scope_ref": "The scope is a reference written module.entity:id.",
    "inventory.refusal.source_move_id": "This is not a move's id.",
    "change.field.item.code": "Code",
    "change.field.item.name_ar": "Name (Arabic)",
    "change.field.item.name_en": "Name (English)",
    "change.field.item.uom": "Unit",
    "change.field.item.default_cost": "Default cost",
    "change.field.item.status": "Status",
    "change.field.item.retired_at": "Retired on",
    "change.field.item.retired_by": "Retired by",
    "change.field.item.created_by": "Added by",
    "change.field.item.store_id": "Store",
    "change.field.item.quantity": "Quantity",
    "change.field.item.value": "Value",
    "change.field.item.last_move_id": "Last move",
    "change.field.item.kind": "Move",
    "change.field.item.item_id": "Item",
    "change.field.item.unit_cost": "Cost of one unit",
    "change.field.item.balance_quantity": "In stock after",
    "change.field.item.balance_value": "Value after",
    "change.field.item.party_id": "Party",
    "change.field.item.party_name": "Received from",
    "change.field.item.ref_entity": "Document type",
    "change.field.item.ref_id": "Document",
    "change.field.item.ref_label": "For",
    "change.field.item.source_move_id": "Move it follows",
    "change.field.item.reason": "Reason",
    "change.field.item.note": "Note",
    "change.field.item.posted_at": "Posted on",
    "change.field.item.posted_by": "Posted by",
    "change.field.store.code": "Code",
    "change.field.store.name_ar": "Name (Arabic)",
    "change.field.store.name_en": "Name (English)",
    "change.field.store.scope_ref": "Belongs to",
    "change.field.store.status": "Status",
    "change.field.store.retired_at": "Retired on",
    "change.field.store.retired_by": "Retired by",
    "change.field.store.created_by": "Added by",
    "inventory.store_members.title": "Members",
    "inventory.col.member": "Member",
    "inventory.col.added_at": "Added",
    "inventory.col.user_id": "User id",
    "inventory.store_members.note": "Members see this store and move its stock. Whoever holds «see every store» sees it without being a member.",
    "inventory.store_members.empty": "Nobody is a member yet: only those who see every store see this one.",
    "inventory.action.add_member": "Add members",
    "inventory.field.user_ids": "Members",
    "inventory.action.remove_member": "Take off this store",
    "inventory.store.tab.members": "Members",
    "inventory.refusal.user_ids_required": "Name at least one member to add.",
    "inventory.refusal.too_many": "Too many at once.",
    "inventory.refusal.user_id": "A member is named by their user id.",
    "inventory.refusal.not_member": "This person is not a member of this store.",
    "inventory.refusal.members_forbidden": "Listing the members needs permission to see users.",
    "inventory.refusal.members_unavailable": "The members could not be listed just now.",
    "change.field.store.user_id": "Member",
    "change.field.store.added_by": "Added by",
    "inventory.item_type.stock": "Stock",
    "inventory.item_type.consumable": "Consumable",
    "inventory.item_type.service": "Service",
    "inventory.item_type.fixed_asset": "Fixed asset",
    "inventory.field.item_type": "Kind",
    "inventory.field.item_type.help": "A service is never stocked. Fixed once stock has moved.",
    "inventory.field.category_id": "Category",
    "inventory.col.category": "Category",
    "inventory.col.item_type": "Kind",
    "inventory.col.category_id": "Category id",
    "inventory.col.parent": "Under",
    "inventory.col.parent_id": "Parent id",
    "inventory.col.items": "Items",
    "inventory.field.parent_id": "Under",
    "inventory.field.parent_id.help": "Categories are one level deep: a parent has none of its own.",
    "inventory.categories.title": "Item categories",
    "inventory.categories.lede": "How items are grouped, one level deep. A ledger that listens maps its accounts by category on its own side.",
    "inventory.categories.empty": "No category yet. Add the first group of items.",
    "inventory.action.create_category": "New category",
    "inventory.action.edit_category": "Edit",
    "inventory.action.retire_category": "Retire",
    "inventory.action.reactivate_category": "Reactivate",
    "nav.inventory.categories": "Item categories",
    "inventory.refusal.item_type_fixed": "Stock of this item has moved; its kind no longer changes.",
    "inventory.refusal.item_type": "The kind is one of stock, consumable, service or fixed asset.",
    "inventory.refusal.category_id": "A category is named by its id.",
    "inventory.refusal.category_not_found": "No such category in this workspace.",
    "inventory.refusal.category_retired": "This category is retired; reactivate it first.",
    "inventory.refusal.parent_id": "A parent is named by its id.",
    "inventory.refusal.parent_self": "A category is not its own parent.",
    "inventory.refusal.parent_nested": "Categories are one level deep: the parent has a parent of its own.",
    "inventory.refusal.parent_has_children": "This category has categories under it; it stays at the top.",
    "inventory.refusal.service_item": "A service is not kept in stock; it has no moves.",
    "change.field.item.category_id": "Category",
    "change.field.item.item_type": "Kind",
    "change.field.category.code": "Code",
    "change.field.category.name_ar": "Name (Arabic)",
    "change.field.category.name_en": "Name (English)",
    "change.field.category.parent_id": "Under",
    "change.field.category.status": "Status",
    "change.field.category.retired_at": "Retired on",
    "change.field.category.retired_by": "Retired by",
    "change.field.category.created_by": "Added by",
    "inventory.uom.bag": "Bag",
    "inventory.uom.carton": "Carton",
    "inventory.uom.dozen": "Dozen",
    "inventory.uom.bottle": "Bottle",
    "inventory.uom.can": "Can",
    "inventory.uom.drum": "Drum",
    "inventory.uom.tube": "Tube",
    "inventory.uom.pallet": "Pallet",
    "inventory.uom.ton": "Ton",
    "inventory.uom.gallon": "Gallon",
    "inventory.uom.mm": "Millimetre",
    "inventory.uom.km": "Kilometre",
    "inventory.uom.minute": "Minute",
    "inventory.uom.day": "Day",
    "inventory.item_uoms.title": "Units",
    "inventory.item_uoms.note": "Stock is kept in the item's own unit; a move entered in another unit is converted exactly, or refused.",
    "inventory.item_uoms.empty": "Counted in its own unit only.",
    "inventory.item.tab.units": "Units",
    "inventory.col.factor": "Holds (in the item's unit)",
    "inventory.col.on_hand_in_uom": "In stock, in this unit",
    "inventory.action.add_uom": "Add a unit",
    "inventory.action.remove_uom": "Take this unit off",
    "inventory.field.alt_uom": "Unit",
    "inventory.field.factor": "One of it holds",
    "inventory.field.factor.help": "In the item's own unit: a bag of an item counted in tons holds 0.05. Or leave it and give how many make one.",
    "inventory.field.per_base": "How many make one of the item's unit",
    "inventory.field.per_base.help": "20 bags to the ton. Give this or the factor.",
    "inventory.refusal.factor_required": "Give the factor, or how many make one of the item's unit — one of the two.",
    "inventory.refusal.factor": "The factor is a number above zero, six decimals at most.",
    "inventory.refusal.factor_inexact": "One unit does not divide into that many exactly; give the factor instead.",
    "inventory.refusal.uom_inexact": "That quantity does not convert exactly into the item's own unit; enter it in the item's unit.",
    "inventory.refusal.uom_decimals": "A quantity in this unit has fewer decimals.",
    "inventory.refusal.uom_not_for_item": "This item is not counted in that unit; add the unit to the item first.",
    "inventory.refusal.uom_is_base": "That is the item's own unit.",
    "inventory.refusal.uom_taken": "This item is counted in that unit already.",
    "inventory.refusal.uom_used": "Moves were entered in this unit; it stays.",
    "inventory.refusal.per_base": "How many make one is a number above zero.",
    "change.field.item.factor": "Factor",
    "change.field.item.entered_quantity": "Quantity entered",
    "change.field.item.entered_uom": "Unit entered",
    "inventory.item_stores.title": "Stores it may be kept in",
    "inventory.item_stores.note": "None named: any store. Once named, the item moves only in these stores.",
    "inventory.item_stores.empty": "Any store may keep this item.",
    "inventory.action.add_item_store": "Add stores",
    "inventory.action.remove_item_store": "Take this store off",
    "inventory.field.store_ids": "Stores",
    "inventory.item.tab.stores": "Stores",
    "inventory.refusal.store_not_allowed": "This item is not kept in this store; add the store to the item first.",
    "inventory.refusal.store_ids_required": "Name at least one store.",
    "inventory.refusal.held_elsewhere": "Stores that hold this item now must be on its list too.",
    "inventory.refusal.store_holds_item": "This store still holds the item; move it out first.",
    "inventory.refusal.store_not_listed": "This store is not on the item's list.",
    "change.field.item.added_by": "Added by",
    "inventory.item_reorder.title": "Reorder levels",
    "inventory.item_reorder.note": "Below the level, the store is announced once, and again only after it is back at or above it.",
    "inventory.item_reorder.empty": "No reorder level is set.",
    "inventory.item.tab.reorder": "Reorder",
    "inventory.col.min_quantity": "Reorder level",
    "inventory.col.reorder_quantity": "Order",
    "inventory.col.below": "Below it",
    "inventory.below.true": "Below",
    "inventory.below.false": "At or above",
    "inventory.col.shortfall": "Shortfall",
    "inventory.col.alerted_at": "Announced",
    "inventory.col.below_reorder": "Below reorder level",
    "inventory.action.set_reorder": "Set a level",
    "inventory.action.remove_reorder": "Remove this level",
    "inventory.field.min_quantity": "Reorder level",
    "inventory.field.min_quantity.help": "In the item's own unit.",
    "inventory.field.reorder_quantity": "How much to order",
    "inventory.reorder.title": "Below reorder level",
    "inventory.reorder.lede": "Every item and store holding less than its reorder level, the largest shortfall first.",
    "inventory.reorder.empty": "Every store holds at least its reorder level.",
    "inventory.stat.run_out": "Run out",
    "inventory.stat.below_reorder": "Below reorder level",
    "nav.inventory.reorder": "Below reorder level",
    "inventory.refusal.min_quantity": "The reorder level is a quantity, zero or more, three decimals at most.",
    "inventory.refusal.reorder_quantity": "How much to order is a quantity above zero.",
    "inventory.refusal.no_reorder_level": "No reorder level is set for this store.",
    "change.field.item.min_quantity": "Reorder level",
    "change.field.item.reorder_quantity": "How much to order",
    "inventory.col.minimum_quantity": "Minimum",
    "inventory.col.below_minimum": "Below the minimum",
    "inventory.mark.below_minimum": "Below the minimum",
    "inventory.stat.below_minimum": "Below the minimum",
    "inventory.field.minimum_quantity": "Minimum level",
    "inventory.field.minimum_quantity.help": "Optional: the least the store must hold, at most the reorder level.",
    "inventory.refusal.minimum_quantity": "The minimum level is a quantity, zero or more, three decimals at most.",
    "inventory.refusal.minimum_above_reorder": "The minimum level is at most the reorder level.",
    "change.field.item.minimum_quantity": "Minimum level",
    "change.field.item.updated_by": "Changed by",
    "inventory.costing.average": "Moving average",
    "inventory.costing.fifo": "First in, first out",
    "inventory.costing.specific": "Specific identification",
    "inventory.field.costing_method": "Costing",
    "inventory.field.costing_method.help": "Empty: the category's method, else the moving average.",
    "inventory.field.costing_method.edit_help": "Changes only while no store holds any of the item.",
    "inventory.field.category_costing.help": "What a new item filed here is costed by when it names none.",
    "inventory.col.costing_method": "Costing",
    "inventory.field.layer_id": "Layer",
    "inventory.field.layer_id.help": "Only for an item costed by specific identification: which receipt goes out.",
    "inventory.refusal.costing_method": "The costing method is the moving average, first in first out, or specific identification.",
    "inventory.refusal.costing_fixed": "Stock of this item is held; its costing method changes only when no store holds any.",
    "inventory.refusal.layer_required": "This item is costed by specific identification: name the layer that goes out.",
    "inventory.refusal.layer_not_found": "No such layer holds this item in this store.",
    "inventory.refusal.layer_not_specific": "A layer is named only for an item costed by specific identification.",
    "inventory.refusal.layer_id": "A layer is named by its id.",
    "change.field.item.costing_method": "Costing",
    "change.field.category.costing_method": "Costing",
    "inventory.field.tracks_lots": "Tracks lots",
    "inventory.field.tracks_lots.help": "Every receipt names a lot and its expiry, and every issue the lot it takes from.",
    "inventory.field.lot_no": "Lot number",
    "inventory.field.lot_no.help": "Required for an item that tracks lots; the same number again adds to that lot.",
    "inventory.field.expires_on": "Expires on",
    "inventory.field.lot_id": "Lot",
    "inventory.field.lot_id.help": "Required for an item that tracks lots; soonest expiry first.",
    "inventory.field.allow_expired_issue": "Issue expired lots",
    "inventory.field.allow_expired_issue.help": "Off by default: an expired lot is written off with an adjustment, not issued.",
    "inventory.field.expiry_warning_days": "Warn days ahead",
    "inventory.field.expiry_warning_days.help": "0 to 365; 30 by default.",
    "inventory.col.lot_no": "Lot",
    "inventory.col.lot_id": "Lot id",
    "inventory.col.expires_on": "Expires on",
    "inventory.col.days_left": "Days left",
    "inventory.col.expiry_state": "Expiry",
    "inventory.col.allow_expired_issue": "Issue expired lots",
    "inventory.col.expiry_warning_days": "Warn days ahead",
    "inventory.expiry_state.expired": "Expired",
    "inventory.expiry_state.expiring": "Expiring soon",
    "inventory.expiry_state.fresh": "In date",
    "inventory.expiry_state.none": "No expiry",
    "inventory.stat.expired": "Expired",
    "inventory.stat.expiring": "Expiring soon",
    "inventory.lots_expiring.title": "Expiring lots",
    "inventory.lots_expiring.lede": "Lots held that have expired or expire within the workspace's warning days, the soonest first.",
    "inventory.lots_expiring.empty": "No lot held expires within the warning days.",
    "inventory.item_lots.title": "Lots",
    "inventory.item_lots.note": "What each lot still holds, soonest expiry first. An expired lot is not issued unless the inventory settings allow it.",
    "inventory.item_lots.empty": "No lot of this item is held.",
    "inventory.item.tab.lots": "Lots",
    "inventory.settings.title": "Inventory settings",
    "inventory.settings.section.stock": "Lots and counts",
    "inventory.settings.section.stock.lede": "Whether an expired lot may be issued, how far ahead the expiring list warns, and what a count’s shortage starts as.",
    "inventory.settings.section.transfers": "Transfers",
    "inventory.settings.section.transfers.lede": "The value above which a transfer waits for approval, and what may be in transit per store.",
    "inventory.settings.lede": "Whether an expired lot may still be issued, and how many days ahead the expiring list warns.",
    "inventory.settings.action.edit": "Change",
    "inventory.yes_no.true": "Yes",
    "inventory.yes_no.false": "No",
    "nav.inventory.lots_expiring": "Expiring lots",
    "nav.inventory.settings": "Inventory settings",
    "change.field.item.tracks_lots": "Tracks lots",
    "change.field.item.lot_id": "Lot",
    "change.field.item.lot_no": "Lot number",
    "change.field.item.expires_on": "Expires on",
    "change.field.item.supplier_party_id": "Supplier",
    "change.field.inventory_settings.allow_expired_issue": "Issue expired lots",
    "change.field.inventory_settings.expiry_warning_days": "Warn days ahead",
    "inventory.refusal.lot_short": "This lot does not hold that much here; take the rest from another lot.",
    "inventory.refusal.lots_fixed": "Stock of this item is held; whether it tracks lots changes only when no store holds any.",
    "inventory.refusal.lot_not_tracked": "This item does not track lots; send no lot.",
    "inventory.refusal.lot_no_required": "This item tracks lots: give the lot number.",
    "inventory.refusal.lot_expiry_mismatch": "This lot was received before with another expiry.",
    "inventory.refusal.lot_required": "This item tracks lots: choose the lot it leaves.",
    "inventory.refusal.lot_not_found": "No such lot of this item.",
    "inventory.refusal.lot_expired": "This lot has expired; it is not issued (write it off with an adjustment).",
    "inventory.refusal.lot_no_on_decrease": "Stock taken out names the lot it leaves, not a new lot number.",
    "inventory.refusal.not_flag": "This is yes or no.",
    "inventory.refusal.expires_on": "The expiry is a calendar day.",
    "inventory.field.manufactured_on": "Made on",
    "inventory.col.manufactured_on": "Made on",
    "change.field.item.manufactured_on": "Made on",
    "inventory.refusal.manufactured_on": "The manufacture date is a calendar day.",
    "inventory.refusal.manufactured_after_expiry": "A lot is made on or before the day it expires.",
    "inventory.refusal.manufactured_in_future": "A lot cannot have been made after today.",
    "inventory.refusal.lot_manufactured_mismatch": "This lot was received before with another manufacture date.",
    "inventory.refusal.lot_no": "A lot number is letters, digits and . _ / -, up to 60.",
    "inventory.refusal.lot_id": "Choose a lot from the list.",
    "inventory.refusal.expiry_warning_days": "Warn a whole number of days ahead, 0 to 365.",
    "inventory.field.store_kind": "Kind",
    "inventory.field.store_kind.help": "A transit store holds only what transfers have on their way.",
    "inventory.col.store_kind": "Kind",
    "inventory.store_kind.regular": "Regular store",
    "inventory.store_kind.transit": "Transit store",
    "inventory.field.pending_cap": "In-transit cap",
    "inventory.field.pending_cap.help": "The most this store may have in transit at once; empty: the workspace's cap.",
    "inventory.col.transfer_approval_above": "Transfers approved above",
    "inventory.col.transfer_pending_cap": "In-transit cap per store",
    "inventory.field.transfer_approval_above": "Transfers approved above",
    "inventory.field.transfer_approval_above.help": "Empty: no transfer waits for approval.",
    "inventory.field.transfer_pending_cap": "In-transit cap per store",
    "inventory.field.transfer_pending_cap.help": "Empty: no cap; a store's own cap comes first.",
    "inventory.kind.transfer_out": "Transfer out",
    "inventory.kind.transfer_in": "Transfer in",
    "change.field.store.kind": "Kind",
    "change.field.store.pending_cap": "In-transit cap",
    "change.field.store.number": "Transfer number",
    "change.field.store.from_store_id": "From store",
    "change.field.store.to_store_id": "To store",
    "change.field.store.via_store_id": "Through transit store",
    "change.field.store.note": "Note",
    "change.field.store.sent_value": "Value sent",
    "change.field.store.received_value": "Value received",
    "change.field.store.approved_at": "Approved at",
    "change.field.store.approved_by": "Approved by",
    "change.field.store.sent_at": "Sent at",
    "change.field.store.sent_by": "Sent by",
    "change.field.store.received_at": "Received at",
    "change.field.store.received_by": "Received by",
    "change.field.store.cancelled_at": "Cancelled at",
    "change.field.store.cancelled_by": "Cancelled by",
    "change.field.item.received_quantity": "Received quantity",
    "change.field.item.discrepancy_quantity": "Discrepancy",
    "change.field.item.discrepancy_note": "Discrepancy note",
    "change.field.inventory_settings.transfer_approval_above": "Transfers approved above",
    "change.field.inventory_settings.transfer_pending_cap": "In-transit cap per store",
    "inventory.refusal.store_kind_fixed": "This store holds stock; whether it is a transit store changes only when it is empty.",
    "inventory.refusal.transit_store": "A transit store moves stock only by transfers.",
    "inventory.refusal.transfer_move": "A transfer's move is not reversed on its own; the transfer is the document.",
    "inventory.refusal.transfer_not_found": "No such transfer in this workspace.",
    "inventory.refusal.transfer_status": "This transfer is not in a state that allows this.",
    "inventory.refusal.own_transfer": "A transfer is approved by someone other than its author.",
    "inventory.refusal.pending_cap": "What is in transit from this store would pass its cap.",
    "inventory.refusal.over_receipt": "More arrived than was sent; receive what was sent and record the rest separately.",
    "inventory.refusal.via_not_transit": "The store a transfer passes through is a transit store.",
    "inventory.refusal.same_store": "A transfer goes to another store.",
    "inventory.refusal.via_store": "The transit store is neither the source nor the destination.",
    "inventory.refusal.lines_required": "A transfer names at least one line.",
    "inventory.refusal.line": "A line is an item and a quantity.",
    "inventory.refusal.line_no": "No such line on this transfer.",
    "inventory.refusal.received_quantity": "What arrived is a quantity, zero or more.",
    "inventory.refusal.from_store_id": "Choose the store it leaves.",
    "inventory.refusal.to_store_id": "Choose the store it goes to.",
    "inventory.refusal.via_store_id": "Choose a transit store.",
    "inventory.refusal.from_store_id_required": "Choose the store it leaves.",
    "inventory.refusal.to_store_id_required": "Choose the store it goes to.",
    "inventory.col.count_shortage_default": "Count shortage",
    "inventory.field.count_shortage_default": "Count shortage",
    "inventory.field.count_shortage_default.help": "What a shortage found by a count starts as; a charge names its party before approval.",
    "inventory.disposition.loss": "A loss",
    "inventory.disposition.charge": "Charged to a party",
    "inventory.store_counts.title": "Counts",
    "inventory.store_counts.note": "Every count of this store, newest first. While a count is open the store is frozen.",
    "inventory.store_counts.empty": "This store has not been counted yet.",
    "inventory.store.tab.counts": "Counts",
    "inventory.col.count_code": "Count",
    "inventory.col.count_scope": "Scope",
    "inventory.count_scope.full": "Whole store",
    "inventory.count_scope.partial": "Some categories",
    "inventory.count_status.counting": "Counting",
    "inventory.count_status.submitted": "Submitted",
    "inventory.count_status.approved": "Approved",
    "inventory.count_status.posted": "Posted",
    "inventory.count_status.cancelled": "Cancelled",
    "inventory.col.shortage_value": "Shortage",
    "inventory.col.surplus_value": "Surplus",
    "inventory.col.opened_at": "Opened",
    "change.field.inventory_settings.count_shortage_default": "Count shortage",
    "change.field.store.scope": "Count scope",
    "change.field.store.blind": "Blind count",
    "change.field.store.shortage_value": "Shortage",
    "change.field.store.surplus_value": "Surplus",
    "change.field.store.submitted_at": "Submitted at",
    "change.field.store.submitted_by": "Submitted by",
    "change.field.store.posted_at": "Posted at",
    "change.field.store.posted_by": "Posted by",
    "change.field.store.store_id": "Store",
    "change.field.item.counted_quantity": "Counted",
    "change.field.item.counted_by": "Counted by",
    "change.field.item.variance_quantity": "Variance",
    "change.field.item.variance_value": "Variance value",
    "change.field.item.disposition": "Settled as",
    "inventory.refusal.store_frozen": "This store is being counted; nothing moves in or out until the count is posted or cancelled.",
    "inventory.refusal.count_not_found": "No such count in this workspace.",
    "inventory.refusal.count_status": "This count is not at that step.",
    "inventory.refusal.uncounted": "Some lines are not counted yet.",
    "inventory.refusal.not_shortage": "Only a shortage is settled.",
    "inventory.refusal.disposition_required": "Settle every shortage first: a loss, or charged to a party.",
    "inventory.refusal.party_required": "A charged shortage names who it is charged to.",
    "inventory.refusal.counted_quantity": "What was counted is a quantity, zero or more.",
    "inventory.refusal.category_ids": "Choose categories from the list.",
    "inventory.refusal.disposition": "A shortage is a loss or charged to a party.",
    "inventory.refusal.count_shortage_default": "A shortage starts as a loss or a charge.",
    "inventory.settings.action.edit_transfers": "Transfers",
    "inventory.col.category_name_ar": "Category",
    "inventory.col.oldest_days": "Oldest (days)",
    "inventory.col.d0_30": "0–30 days",
    "inventory.col.d31_90": "31–90 days",
    "inventory.col.d91_180": "91–180 days",
    "inventory.col.d180_plus": "Over 180 days",
    "inventory.col.month": "Month",
    "inventory.stat.stale": "Held over 180 days",
    "inventory.aging.title": "Stock aging",
    "inventory.aging.lede": "What each store holds of each item by how long ago it came in, from the cost layers; the totals are over the whole filter.",
    "inventory.aging.empty": "No stock is held.",
    "inventory.consumption.title": "Consumption",
    "inventory.consumption.lede": "What was issued, net of returns, per month, store, item and the document it went to; filter by document, item, category or months, and the totals follow.",
    "inventory.consumption.empty": "Nothing was consumed in this period.",
    "nav.inventory.aging": "Stock aging",
    "nav.inventory.consumption": "Consumption",
    "inventory.refusal.group": "Group by document, item or category.",
    "inventory.refusal.period": "The period is given in calendar days, and ends on or after it starts.",
    "nav.inventory.transfers": "Transfers",
    "screen.inventory.transfers.title": "Transfers",
    "screen.inventory.transfer.title": "Transfer",
    "entity.inventory.transfer": "Transfer",
    "inventory.transfers.title": "Transfers",
    "inventory.transfers.lede": "Stock moved between stores, directly or through a transit store, from the draft to its receipt.",
    "inventory.transfers.empty": "No transfers yet.",
    "inventory.transfer.title": "Transfer",
    "inventory.transfer.monogram": "TR",
    "inventory.transfer.direct": "Direct",
    "inventory.transfer_status.draft": "Draft",
    "inventory.transfer_status.awaiting_approval": "Awaiting approval",
    "inventory.transfer_status.in_transit": "In transit",
    "inventory.transfer_status.received": "Received",
    "inventory.transfer_status.cancelled": "Cancelled",
    "inventory.stat.in_transit_value": "Value in transit",
    "inventory.col.transfer": "Transfer",
    "inventory.col.transfer_code": "Number",
    "inventory.col.from_store": "From",
    "inventory.col.to_store": "To",
    "inventory.col.via_store": "Through",
    "inventory.col.from_store_id": "From store id",
    "inventory.col.to_store_id": "To store id",
    "inventory.col.via_store_id": "Transit store id",
    "inventory.col.via": "Through a transit store",
    "inventory.col.line_count": "Lines",
    "inventory.col.sent_value": "Value sent",
    "inventory.col.received_value": "Value received",
    "inventory.col.sent_at": "Sent",
    "inventory.col.received_at": "Received",
    "inventory.col.approved_at": "Approved",
    "inventory.col.drafted_at": "Drafted",
    "inventory.col.updated_at": "Changed",
    "inventory.col.drafted_by": "Drafted by",
    "inventory.col.sent_by": "Sent by",
    "inventory.col.approved_by": "Approved by",
    "inventory.col.received_by": "Received by",
    "inventory.col.created_by": "Drafted by id",
    "inventory.col.sent_by_id": "Sent by id",
    "inventory.col.approved_by_id": "Approved by id",
    "inventory.col.received_by_id": "Received by id",
    "inventory.col.quantity_sent": "Sent",
    "inventory.col.received_quantity": "Received",
    "inventory.col.discrepancy_quantity": "Discrepancy",
    "inventory.col.discrepancy_note": "Discrepancy note",
    "inventory.col.can_send": "Can be sent",
    "inventory.col.can_approve": "Can be approved",
    "inventory.col.can_receive": "Can be received",
    "inventory.col.can_cancel": "Can be cancelled",
    "inventory.col.ref_token": "Document reference",
    "inventory.field.from_store_id": "From store",
    "inventory.field.to_store_id": "To store",
    "inventory.field.via_store_id": "Through a transit store",
    "inventory.field.via_store_id.help": "Leave it empty for a direct transfer.",
    "inventory.field.transfer_lines": "Lines",
    "inventory.transfer.action.create": "New transfer",
    "inventory.transfer.action.create.effect": "A lot-tracked item leaves its soonest-expiring lots first.",
    "inventory.transfer.action.send": "Send",
    "inventory.transfer.action.send.effect": "The stock leaves the source now; above the workspace's approval value it waits for approval first.",
    "inventory.transfer.action.approve": "Approve and send",
    "inventory.transfer.action.approve.effect": "The stock leaves the source as soon as it is approved.",
    "inventory.transfer.action.receive": "Confirm receipt",
    "inventory.transfer.action.cancel": "Cancel",
    "inventory.transfer.action.cancel.effect": "Nothing has moved yet; the transfer stays on record as cancelled.",
    "inventory.transfer.alert.awaiting_other": "Waiting for someone else to approve it",
    "inventory.transfer.alert.approve": "Worth more than the approval value: approve it to send it",
    "inventory.transfer.alert.in_transit": "On its way through the transit store: the destination confirms what arrived",
    "inventory.transfer.tab.lines": "Lines",
    "inventory.transfer.tab.details": "Details",
    "inventory.transfer.lines.note": "What did not arrive is the line's discrepancy, written off the transit store.",
    "inventory.store.tab.transfers": "Transfers",
    "inventory.store_transfers.title": "Transfers",
    "inventory.store_transfers.note": "In and out of this store; those awaiting approval or in transit first.",
    "inventory.store_transfers.empty": "No stock has been transferred to or from this store.",
    "inventory.receive.title": "Confirm receipt of {code}",
    "inventory.receive.lede": "What arrived, line by line; each line arrived whole unless you say less.",
    "inventory.receive.notice": "What did not arrive is recorded as a discrepancy and written off the transit store.",
    "inventory.receive.note_required": "Say why less arrived than was sent.",
    "inventory.receive.short": "{n} lines arrived short; their difference is written off the transit store.",
    "inventory.receive.saved": "Receipt confirmed",
    "inventory.receive.no_row": "Open this from a transfer.",
    "inventory.receive.not_in_transit": "This transfer is not in transit any more.",
    "inventory.refusal.store_kind": "A store is a regular store or a transit store.",
    "nav.inventory.counts": "Stock counts",
    "inventory.counts.title": "Stock counts",
    "inventory.counts.lede": "A store counted, its variances settled and posted as adjustments; the store is frozen while a count is open.",
    "inventory.counts.empty": "No store has been counted yet.",
    "inventory.stat.open_counts": "Open counts",
    "inventory.col.blind": "Blind count",
    "inventory.col.can_count": "Can be counted",
    "inventory.col.can_submit": "Can be submitted",
    "inventory.col.can_post": "Can be posted",
    "inventory.col.can_settle": "Can be settled",
    "inventory.col.cancelled_at": "Cancelled",
    "inventory.col.cancelled_by": "Cancelled by",
    "inventory.col.cancelled_by_id": "Cancelled by id",
    "inventory.col.count": "Count",
    "inventory.col.count_id": "Count id",
    "inventory.col.count_party": "Party",
    "inventory.col.counted_at": "Counted at",
    "inventory.col.counted_by": "Counted by",
    "inventory.col.counted_by_id": "Counted by id",
    "inventory.col.counted_count": "Lines counted",
    "inventory.col.counted_quantity": "Counted",
    "inventory.col.expected_quantity": "Expected",
    "inventory.col.disposition": "Settled as",
    "inventory.col.is_shortage": "Shortage",
    "inventory.col.line_no": "Line",
    "inventory.col.opened_by": "Opened by",
    "inventory.col.opened_by_id": "Opened by id",
    "inventory.col.posted_by": "Posted by",
    "inventory.col.posted_by_id": "Posted by id",
    "inventory.col.submitted_at": "Submitted",
    "inventory.col.submitted_by": "Submitted by",
    "inventory.col.submitted_by_id": "Submitted by id",
    "inventory.col.variance_kind": "Variance kind",
    "inventory.col.variance_quantity": "Variance",
    "inventory.col.variance_value": "Variance value",
    "inventory.variance_kind.shortage": "Shortage",
    "inventory.variance_kind.surplus": "Surplus",
    "inventory.variance_kind.none": "Matches",
    "inventory.count.title": "Stock count",
    "inventory.count.blind_mark": "Blind",
    "inventory.count.monogram": "CT",
    "inventory.count.tab.lines": "Lines",
    "inventory.count.tab.details": "Details",
    "inventory.count.action.create": "Open a count",
    "inventory.count.action.count": "Count",
    "inventory.count.action.submit": "Submit for review",
    "inventory.count.action.submit.effect": "Refused while a line is uncounted. The variances are known from then on.",
    "inventory.count.action.approve": "Approve",
    "inventory.count.action.approve.effect": "Refused while a shortage is not settled as a loss or charged to a party.",
    "inventory.count.action.post": "Post",
    "inventory.count.action.post.effect": "Each variance becomes a stock adjustment, a charged shortage is sent to be recovered, and the store is unfrozen.",
    "inventory.count.action.cancel": "Cancel",
    "inventory.count.action.cancel.effect": "Nothing is adjusted; the store is unfrozen and the count stays on record as cancelled.",
    "inventory.count.action.settle": "Settle",
    "inventory.count.alert.counting": "Being counted: the store is frozen until the count is posted or cancelled",
    "inventory.count.alert.settle": "Settle each shortage on the lines as a loss or charged to a party, then approve",
    "inventory.count.alert.post": "Approved: post it to adjust the stock and unfreeze the store",
    "inventory.count_lines.title": "Lines",
    "inventory.count_lines.note": "A blind count shows what was expected once it is submitted. Each shortage is settled before the count is approved.",
    "inventory.count_lines.empty": "This count has no lines: the store held nothing in its scope.",
    "inventory.field.count_store_id.help": "Opening a count freezes the store: nothing is received, issued or transferred until it is posted or cancelled.",
    "inventory.field.category_ids": "Categories",
    "inventory.field.category_ids.help": "Empty: the whole store. A category includes the ones under it.",
    "inventory.field.blind": "Blind count",
    "inventory.field.blind.help": "Hides the expected quantity from the counters until the count is submitted.",
    "inventory.field.count_party.help": "Who the shortage is recovered from, when the count is posted.",
    "inventory.counting.screen": "Counting",
    "inventory.counting.lede": "Each line of an open count, counted and saved; then submitted for review.",
    "inventory.counting.title": "Counting {code}",
    "inventory.counting.no_id": "Open this page from a count.",
    "inventory.counting.closed": "This count is no longer being counted.",
    "inventory.counting.closed.detail": "It has been submitted, posted or cancelled; its record shows what was found.",
    "inventory.counting.empty": "Nothing to count.",
    "inventory.counting.empty.detail": "The store held nothing in this count's scope when it was opened.",
    "inventory.counting.blind": "A blind count: the expected quantity is hidden until the count is submitted.",
    "inventory.counting.progress": "{n} of {of} counted",
    "inventory.counting.next": "Next line",
    "inventory.counting.save_next": "Save and next",
    "inventory.counting.all_counted": "Every line is counted: submit it for review.",
    "inventory.counting.lines": "All lines",
    "inventory.counting.lines.detail": "Correct a count here; the last entry stands.",
    "inventory.counting.save": "Save changes ({n})",
    "inventory.counting.saved": "Saved.",
    "inventory.counting.submitted": "Submitted for review.",
    "inventory.counting.left": "{n} lines are still to be counted.",
    // The member's page: the stores they work in (pm core-qkg4b5kj).
    "inventory.member_stores.title": "Data scope: stores",
    "inventory.member_store_scope.title": "Store scope",
    "inventory.col.store_scope": "Stores they see",
    "inventory.store_scope.all": "Every store (by permission)",
    "inventory.store_scope.listed": "Named stores only",
    "inventory.store_scope.none": "None — sees no stock",
    "inventory.member_stores.note": "Members see a store and move its stock. Whoever holds «see every store» sees every store without being a member.",
    "inventory.member_stores.empty": "Not a member of any store you see.",
    "inventory.action.add_stores": "Add to stores",
    "inventory.refusal.member_not_found": "No such member in this workspace.",
};
export const INVENTORY_AR = {
    "inventory.uom.piece": "حبة",
    "inventory.uom.box": "صندوق",
    "inventory.uom.pack": "عبوة",
    "inventory.uom.set": "طقم",
    "inventory.uom.pair": "زوج",
    "inventory.uom.roll": "لفة",
    "inventory.uom.sheet": "لوح",
    "inventory.uom.kg": "كيلوغرام",
    "inventory.uom.g": "غرام",
    "inventory.uom.litre": "لتر",
    "inventory.uom.ml": "ملّيلتر",
    "inventory.uom.metre": "متر",
    "inventory.uom.cm": "سنتيمتر",
    "inventory.uom.sq_metre": "متر مربع",
    "inventory.uom.cubic_metre": "متر مكعب",
    "inventory.uom.hour": "ساعة",
    "inventory.kind.receipt": "استلام",
    "inventory.kind.issue": "صرف",
    "inventory.kind.return": "مرتجع",
    "inventory.kind.adjustment": "تسوية",
    "inventory.kind.reversal": "عكس",
    "inventory.reason.count": "جرد",
    "inventory.reason.damage": "تالف",
    "inventory.reason.loss": "مفقود",
    "inventory.reason.found": "زيادة عند الجرد",
    "inventory.reason.opening": "رصيد افتتاحي",
    "inventory.reason.expiry": "منتهي الصلاحية",
    "inventory.reason.other": "سبب آخر",
    "inventory.status.active": "قيد الاستخدام",
    "inventory.status.retired": "موقوف",
    "inventory.col.name_ar": "الصنف",
    "inventory.col.code": "الرمز",
    "inventory.col.on_hand": "الكمية المتوفرة",
    "inventory.col.uom": "الوحدة",
    "inventory.col.stock_value": "قيمة المخزون",
    "inventory.col.status": "الحالة",
    "inventory.col.name_en": "الاسم بالإنجليزية",
    "inventory.col.default_cost": "التكلفة الافتراضية",
    "inventory.col.id": "المعرّف",
    "inventory.col.version": "الإصدار",
    "inventory.col.can_edit": "قابل للتعديل",
    "inventory.col.can_retire": "قابل للإيقاف",
    "inventory.col.can_reactivate": "قابل لإعادة التفعيل",
    "inventory.field.store_id": "المستودع",
    "inventory.field.quantity": "الكمية",
    "inventory.field.unit_cost": "تكلفة الوحدة",
    "inventory.field.unit_cost.help": "إن تُرك فارغاً: التكلفة الافتراضية للصنف.",
    "inventory.field.party_id": "مُستلَم من",
    "inventory.field.note": "ملاحظة",
    "inventory.action.receive": "استلام",
    "inventory.field.ref_label": "مصروف لأجل",
    "inventory.field.ref_label.help": "ما الذي يُصرف المخزون من أجله.",
    "inventory.action.issue": "صرف",
    "inventory.field.delta": "مقدار التغيير",
    "inventory.field.delta.help": "الموجب يضيف إلى المستودع، والسالب يُنقص منه.",
    "inventory.field.added_cost": "تكلفة الوحدة",
    "inventory.field.added_cost.help": "للكمية المضافة فقط. إن تُرك فارغاً: متوسط التكلفة.",
    "inventory.field.reason": "السبب",
    "inventory.action.adjust": "تسوية",
    "inventory.field.name_ar": "الاسم بالعربية",
    "inventory.field.name_en": "الاسم بالإنجليزية",
    "inventory.field.uom": "وحدة العدّ",
    "inventory.field.uom.help": "لا تتغير بعد أول حركة مخزون.",
    "inventory.field.default_cost": "التكلفة الافتراضية",
    "inventory.field.default_cost.help": "تكلفة الوحدة عند الاستلام إن لم تُذكر تكلفة.",
    "inventory.action.edit": "تعديل",
    "inventory.action.retire": "إيقاف الصنف",
    "inventory.action.reactivate": "إعادة التفعيل",
    "inventory.items.title": "الأصناف",
    "inventory.items.lede": "ما تحفظه المنشأة في مستودعاتها، مع الكمية المتوفرة وتكلفتها.",
    "inventory.stat.out_of_stock": "نفد مخزونها",
    "inventory.items.empty": "لا أصناف بعد. أضف أول ما تحفظه المنشأة في المخزون.",
    "inventory.field.code": "الرمز",
    "inventory.field.code.help": "ما يُكتب ويُطبع. حروف وأرقام و . _ - ولا يتغير.",
    "inventory.action.create": "صنف جديد",
    "inventory.col.store_name_ar": "المستودع",
    "inventory.col.held": "الكمية المتوفرة",
    "inventory.col.average_cost": "متوسط التكلفة",
    "inventory.col.held_value": "قيمة المخزون",
    "inventory.col.store_id": "معرّف المستودع",
    "inventory.item.title": "صنف",
    "inventory.col.store_count": "مستودعات تحفظه",
    "inventory.col.created_at": "أُضيف",
    "inventory.col.retired_at": "أُوقف",
    "inventory.item.table.balances": "حسب المستودع",
    "inventory.item.table.balances.note": "متوسط التكلفة هو قيمة ما في المستودع مقسومة على كميته، ويتغير مع كل استلام.",
    "inventory.item.tab.moves": "الحركات",
    "inventory.item.monogram": "صن",
    "inventory.item_moves.title": "الحركات",
    "inventory.col.posted_at": "تاريخ الترحيل",
    "inventory.col.kind": "الحركة",
    "inventory.col.quantity": "الكمية",
    "inventory.col.value": "القيمة",
    "inventory.col.ref_label": "لأجل",
    "inventory.col.item_id": "معرّف الصنف",
    "inventory.moves.card.empty": "لم تتحرك أي كمية بعد.",
    "inventory.col.item_name_ar": "الصنف",
    "inventory.store_moves.title": "الحركات",
    "inventory.action.edit_store": "تعديل",
    "inventory.action.retire_store": "إيقاف المستودع",
    "inventory.action.reactivate_store": "إعادة التفعيل",
    "inventory.stores.title": "المستودعات",
    "inventory.stores.lede": "حيث يُحفظ المخزون؛ ويُوقف المستودع متى خلا من أي كمية.",
    "inventory.stores.empty": "لا مستودعات بعد. أضف أول مكان يُحفظ فيه المخزون.",
    "inventory.col.store_name": "المستودع",
    "inventory.col.item_count": "أصناف محفوظة",
    "inventory.col.scope_ref": "يتبع",
    "inventory.action.create_store": "مستودع جديد",
    "inventory.store.title": "مستودع",
    "inventory.store.table.balances": "ما يحفظه",
    "inventory.store.monogram": "مس",
    "inventory.moves.title": "حركات المخزون",
    "inventory.moves.lede": "كل استلام وصرف ومرتجع وتسوية كما رُحّل؛ ويُصحَّح الخطأ بعكسه.",
    "inventory.moves.empty": "لم تتحرك أي كمية بعد. ابدأ باستلام مخزون.",
    "inventory.col.party_name": "مُستلَم من",
    "inventory.col.unit_cost": "تكلفة الوحدة",
    "inventory.col.balance_quantity": "المتوفر بعدها",
    "inventory.col.reason": "السبب",
    "inventory.col.note": "ملاحظة",
    "inventory.col.returnable": "ما زال مصروفاً",
    "inventory.col.party_id": "معرّف الطرف",
    "inventory.col.ref_entity": "نوع المستند",
    "inventory.col.ref_id": "المستند",
    "inventory.col.reversed": "معكوسة",
    "inventory.col.can_return": "قابلة للإرجاع",
    "inventory.col.can_reverse": "قابلة للعكس",
    "inventory.field.item_id": "الصنف",
    "inventory.action.receive_any": "استلام مخزون",
    "inventory.action.issue_any": "صرف مخزون",
    "inventory.action.adjust_any": "تسوية مخزون",
    "inventory.field.return_quantity": "الكمية المرتجعة",
    "inventory.field.return_quantity.help": "بحدّ أقصى ما زال مصروفاً.",
    "inventory.action.return": "استرجاع",
    "inventory.field.reverse_reason": "سبب العكس",
    "inventory.field.reverse_reason.help": "تبقى الحركة في السجل، وتُرحَّل عكسها بجانبها.",
    "inventory.action.reverse": "عكس",
    "nav.module.inventory": "المخزون",
    "nav.inventory.items": "الأصناف",
    "nav.inventory.moves": "حركات المخزون",
    "nav.inventory.stores": "المستودعات",
    "screen.inventory.items.title": "الأصناف",
    "screen.inventory.item.title": "صنف",
    "screen.inventory.stores.title": "المستودعات",
    "screen.inventory.store.title": "مستودع",
    "screen.inventory.moves.title": "حركات المخزون",
    "entity.inventory.item": "صنف",
    "entity.inventory.store": "مستودع",
    "inventory.refusal.active": "هذا قيد الاستخدام أصلاً.",
    "inventory.refusal.code": "الرمز حروف وأرقام و . _ - حتى 40 خانة.",
    "inventory.refusal.code_required": "أدخل الرمز.",
    "inventory.refusal.code_fixed": "الرمز لا يتغير؛ أوقف هذا وأضف غيره.",
    "inventory.refusal.code_taken": "هذا الرمز مستخدم في هذه المنشأة.",
    "inventory.refusal.consumed_at_other_cost": "ما أدخلته هذه الحركة صُرف بعدها بتكلفة أخرى؛ صحّحه بتسوية.",
    "inventory.refusal.cost": "التكلفة مبلغ بأربع خانات عشرية على الأكثر، وليست سالبة.",
    "inventory.refusal.cost_on_decrease": "الكمية المُنقصة تخرج بمتوسط التكلفة؛ لا تُدخل تكلفة.",
    "inventory.refusal.delta": "أدخل تغييراً غير الصفر: الموجب يضيف والسالب يُنقص.",
    "inventory.refusal.has_returns": "أُرجع جزء من هذا الصرف؛ اعكس مرتجعاته أولاً.",
    "inventory.refusal.holds_stock": "ما زال من هذا الصنف كمية في المخزون ({on_hand})؛ اصرفها أو سوِّها إلى الصفر أولاً.",
    "inventory.refusal.item_not_found": "لا يوجد هذا الصنف.",
    "inventory.refusal.item_retired": "هذا الصنف موقوف؛ أعد تفعيله أولاً.",
    "inventory.refusal.item_id": "اختر صنفاً.",
    "inventory.refusal.item_id_required": "اختر صنفاً.",
    "inventory.refusal.key_required": "تُرسل الحركة على مستند بمفتاح منع تكرار، حتى لا تتحرك الكمية مرتين عند إعادة المحاولة.",
    "inventory.refusal.limit": "الحد عدد صحيح من 1 إلى 500.",
    "inventory.refusal.move_not_found": "لا توجد هذه الحركة.",
    "inventory.refusal.not_issue": "لا يُسترجع إلا الصرف.",
    "inventory.refusal.not_text": "يجب أن تكون هذه القيمة نصاً.",
    "inventory.refusal.note_required": "اذكر سبب التسوية.",
    "inventory.refusal.over_return": "ما زال من هذا الصرف {available} فقط.",
    "inventory.refusal.party": "لا يوجد هذا الطرف ضمن ما يحق لك رؤيته.",
    "inventory.refusal.party_id": "اختر طرفاً.",
    "inventory.refusal.quantity": "الكمية عدد أكبر من الصفر بثلاث خانات عشرية على الأكثر.",
    "inventory.refusal.quantity_required": "أدخل الكمية.",
    "inventory.refusal.ref": "يُسمّى المستند بنوعه ومعرّفه معاً.",
    "inventory.refusal.ref_entity": "نوع المستند يُكتب module.entity.",
    "inventory.refusal.ref_id": "معرّف المستند حروف وأرقام و _ . : -.",
    "inventory.refusal.ref_label_required": "اذكر ما يُصرف المخزون لأجله.",
    "inventory.refusal.retired": "هذا موقوف.",
    "inventory.refusal.reverse_reversal": "لا يُعكس العكس؛ رحّل الحركة من جديد.",
    "inventory.refusal.reversed": "عُكست هذه الحركة.",
    "inventory.refusal.short": "المتوفر في هذا المستودع {available} فقط.",
    "inventory.refusal.stale": "تغيّر هذا منذ فتحته. أعد التحميل وحاول مجدداً.",
    "inventory.refusal.status": "اختر قيد الاستخدام أو موقوف.",
    "inventory.refusal.status_route": "يُوقف ويُعاد تفعيله من إجرائه الخاص.",
    "inventory.refusal.store_holds_stock": "ما زال في هذا المستودع {items} أصناف؛ أخرجها أولاً.",
    "inventory.refusal.store_not_found": "لا يوجد هذا المستودع.",
    "inventory.refusal.store_retired": "هذا المستودع موقوف؛ أعد تفعيله أولاً.",
    "inventory.refusal.store_id": "اختر مستودعاً.",
    "inventory.refusal.store_id_required": "اختر مستودعاً.",
    "inventory.refusal.too_long": "هذا أطول من {max} حرفاً.",
    "inventory.refusal.unit_cost_required": "أدخل تكلفة الوحدة: ليس لهذا الصنف تكلفة افتراضية.",
    "inventory.refusal.uom": "اختر وحدة من القائمة.",
    "inventory.refusal.uom_required": "اختر وحدة العدّ.",
    "inventory.refusal.uom_fixed": "تحرّك مخزون هذا الصنف؛ فلا تتغير وحدته.",
    "inventory.refusal.version": "الإصدار هو العدد الصحيح الذي قُرئ عنده السجل.",
    "inventory.refusal.name_ar_required": "أدخل الاسم بالعربية.",
    "inventory.refusal.reason": "اختر سبباً من القائمة.",
    "inventory.refusal.reason_required": "اذكر السبب.",
    "inventory.refusal.kind": "اختر نوع حركة من القائمة.",
    "inventory.refusal.scope_ref": "النطاق مرجع يُكتب module.entity:id.",
    "inventory.refusal.source_move_id": "هذا ليس معرّف حركة.",
    "change.field.item.code": "الرمز",
    "change.field.item.name_ar": "الاسم (عربي)",
    "change.field.item.name_en": "الاسم (إنجليزي)",
    "change.field.item.uom": "الوحدة",
    "change.field.item.default_cost": "التكلفة الافتراضية",
    "change.field.item.status": "الحالة",
    "change.field.item.retired_at": "تاريخ الإيقاف",
    "change.field.item.retired_by": "أوقفه",
    "change.field.item.created_by": "أضافه",
    "change.field.item.store_id": "المستودع",
    "change.field.item.quantity": "الكمية",
    "change.field.item.value": "القيمة",
    "change.field.item.last_move_id": "آخر حركة",
    "change.field.item.kind": "الحركة",
    "change.field.item.item_id": "الصنف",
    "change.field.item.unit_cost": "تكلفة الوحدة",
    "change.field.item.balance_quantity": "المتوفر بعدها",
    "change.field.item.balance_value": "القيمة بعدها",
    "change.field.item.party_id": "الطرف",
    "change.field.item.party_name": "مُستلَم من",
    "change.field.item.ref_entity": "نوع المستند",
    "change.field.item.ref_id": "المستند",
    "change.field.item.ref_label": "لأجل",
    "change.field.item.source_move_id": "الحركة الأصل",
    "change.field.item.reason": "السبب",
    "change.field.item.note": "ملاحظة",
    "change.field.item.posted_at": "تاريخ الترحيل",
    "change.field.item.posted_by": "رحّلها",
    "change.field.store.code": "الرمز",
    "change.field.store.name_ar": "الاسم (عربي)",
    "change.field.store.name_en": "الاسم (إنجليزي)",
    "change.field.store.scope_ref": "يتبع",
    "change.field.store.status": "الحالة",
    "change.field.store.retired_at": "تاريخ الإيقاف",
    "change.field.store.retired_by": "أوقفه",
    "change.field.store.created_by": "أضافه",
    "inventory.store_members.title": "الأعضاء",
    "inventory.col.member": "العضو",
    "inventory.col.added_at": "أُضيف في",
    "inventory.col.user_id": "معرّف المستخدم",
    "inventory.store_members.note": "يرى الأعضاء هذا المستودع ويحرّكون مخزونه. ومن يملك صلاحية «يرى كل المستودعات» يراه دون أن يكون عضوًا.",
    "inventory.store_members.empty": "لا أعضاء بعد: لا يرى هذا المستودع إلا من يرى كل المستودعات.",
    "inventory.action.add_member": "إضافة أعضاء",
    "inventory.field.user_ids": "الأعضاء",
    "inventory.action.remove_member": "إزالة من المستودع",
    "inventory.store.tab.members": "الأعضاء",
    "inventory.refusal.user_ids_required": "اختر عضوًا واحدًا على الأقل لإضافته.",
    "inventory.refusal.too_many": "العدد أكبر من المسموح دفعة واحدة.",
    "inventory.refusal.user_id": "يُحدَّد العضو بمعرّف المستخدم.",
    "inventory.refusal.not_member": "هذا الشخص ليس عضوًا في هذا المستودع.",
    "inventory.refusal.members_forbidden": "عرض الأعضاء يحتاج صلاحية رؤية المستخدمين.",
    "inventory.refusal.members_unavailable": "تعذّر عرض الأعضاء الآن.",
    "change.field.store.user_id": "العضو",
    "change.field.store.added_by": "أضافه",
    "inventory.item_type.stock": "مخزني",
    "inventory.item_type.consumable": "مستهلك",
    "inventory.item_type.service": "خدمة",
    "inventory.item_type.fixed_asset": "أصل ثابت",
    "inventory.field.item_type": "النوع",
    "inventory.field.item_type.help": "الخدمة لا تُخزَّن. ويثبت النوع بعد أول حركة مخزون.",
    "inventory.field.category_id": "الفئة",
    "inventory.col.category": "الفئة",
    "inventory.col.item_type": "النوع",
    "inventory.col.category_id": "معرّف الفئة",
    "inventory.col.parent": "تحت",
    "inventory.col.parent_id": "معرّف الأصل",
    "inventory.col.items": "الأصناف",
    "inventory.field.parent_id": "تحت فئة",
    "inventory.field.parent_id.help": "الفئات مستوى واحد: الفئة الأم لا أمّ لها.",
    "inventory.categories.title": "فئات الأصناف",
    "inventory.categories.lede": "كيف تُجمَع الأصناف، بمستوى واحد. ودفتر الحسابات الذي يستمع يربط حساباته بالفئة من جهته.",
    "inventory.categories.empty": "لا فئة بعد. أضف أول مجموعة من الأصناف.",
    "inventory.action.create_category": "فئة جديدة",
    "inventory.action.edit_category": "تعديل",
    "inventory.action.retire_category": "إيقاف",
    "inventory.action.reactivate_category": "إعادة التفعيل",
    "nav.inventory.categories": "فئات الأصناف",
    "inventory.refusal.item_type_fixed": "تحرّك مخزون هذا الصنف؛ فلا يتغيّر نوعه بعد الآن.",
    "inventory.refusal.item_type": "النوع واحد من: مخزني، مستهلك، خدمة، أصل ثابت.",
    "inventory.refusal.category_id": "تُحدَّد الفئة بمعرّفها.",
    "inventory.refusal.category_not_found": "لا توجد هذه الفئة في مساحة العمل.",
    "inventory.refusal.category_retired": "هذه الفئة موقوفة؛ أعد تفعيلها أولًا.",
    "inventory.refusal.parent_id": "تُحدَّد الفئة الأم بمعرّفها.",
    "inventory.refusal.parent_self": "لا تكون الفئة أمًّا لنفسها.",
    "inventory.refusal.parent_nested": "الفئات مستوى واحد: للفئة الأم فئة أمّ.",
    "inventory.refusal.parent_has_children": "تحت هذه الفئة فئات أخرى؛ فتبقى في المستوى الأعلى.",
    "inventory.refusal.service_item": "الخدمة لا تُخزَّن؛ فلا حركات لها.",
    "change.field.item.category_id": "الفئة",
    "change.field.item.item_type": "النوع",
    "change.field.category.code": "الرمز",
    "change.field.category.name_ar": "الاسم بالعربية",
    "change.field.category.name_en": "الاسم بالإنجليزية",
    "change.field.category.parent_id": "تحت فئة",
    "change.field.category.status": "الحالة",
    "change.field.category.retired_at": "أُوقفت في",
    "change.field.category.retired_by": "أوقفها",
    "change.field.category.created_by": "أضافها",
    "inventory.uom.bag": "كيس",
    "inventory.uom.carton": "كرتون",
    "inventory.uom.dozen": "دزينة",
    "inventory.uom.bottle": "عبوة",
    "inventory.uom.can": "علبة",
    "inventory.uom.drum": "برميل",
    "inventory.uom.tube": "أنبوب",
    "inventory.uom.pallet": "منصّة",
    "inventory.uom.ton": "طن",
    "inventory.uom.gallon": "جالون",
    "inventory.uom.mm": "مليمتر",
    "inventory.uom.km": "كيلومتر",
    "inventory.uom.minute": "دقيقة",
    "inventory.uom.day": "يوم",
    "inventory.item_uoms.title": "الوحدات",
    "inventory.item_uoms.note": "يُحفظ المخزون بوحدة الصنف نفسها؛ والحركة المُدخلة بوحدة أخرى تُحوَّل تحويلًا دقيقًا أو تُرفض.",
    "inventory.item_uoms.empty": "يُعدّ بوحدته فقط.",
    "inventory.item.tab.units": "الوحدات",
    "inventory.col.factor": "تعادل (بوحدة الصنف)",
    "inventory.col.on_hand_in_uom": "المتوفر بهذه الوحدة",
    "inventory.action.add_uom": "إضافة وحدة",
    "inventory.action.remove_uom": "إزالة هذه الوحدة",
    "inventory.field.alt_uom": "الوحدة",
    "inventory.field.factor": "الواحدة منها تعادل",
    "inventory.field.factor.help": "بوحدة الصنف: كيس صنفٍ يُعدّ بالطن يعادل 0.05. أو اتركه واذكر كم منها يساوي وحدة واحدة.",
    "inventory.field.per_base": "كم منها يساوي وحدة الصنف",
    "inventory.field.per_base.help": "20 كيسًا في الطن. اذكر هذا أو المعادل.",
    "inventory.refusal.factor_required": "اذكر المعادل أو كم منها يساوي وحدة الصنف — أحدهما فقط.",
    "inventory.refusal.factor": "المعادل رقم أكبر من الصفر، بست خانات عشرية على الأكثر.",
    "inventory.refusal.factor_inexact": "لا تنقسم الوحدة على هذا العدد قسمة دقيقة؛ اذكر المعادل بدلًا منه.",
    "inventory.refusal.uom_inexact": "هذه الكمية لا تتحوّل تحويلًا دقيقًا إلى وحدة الصنف؛ أدخلها بوحدة الصنف.",
    "inventory.refusal.uom_decimals": "الكمية بهذه الوحدة خاناتها العشرية أقل.",
    "inventory.refusal.uom_not_for_item": "هذا الصنف لا يُعدّ بهذه الوحدة؛ أضف الوحدة إلى الصنف أولًا.",
    "inventory.refusal.uom_is_base": "هذه وحدة الصنف نفسها.",
    "inventory.refusal.uom_taken": "هذا الصنف يُعدّ بهذه الوحدة من قبل.",
    "inventory.refusal.uom_used": "أُدخلت حركات بهذه الوحدة؛ فتبقى.",
    "inventory.refusal.per_base": "العدد الذي يساوي وحدة واحدة رقم أكبر من الصفر.",
    "change.field.item.factor": "المعادل",
    "change.field.item.entered_quantity": "الكمية المُدخلة",
    "change.field.item.entered_uom": "الوحدة المُدخلة",
    "inventory.item_stores.title": "المستودعات المسموح بها",
    "inventory.item_stores.note": "إن لم يُحدَّد مستودع فأي مستودع. وإذا حُدّدت فلا يتحرّك الصنف إلا فيها.",
    "inventory.item_stores.empty": "يجوز حفظ هذا الصنف في أي مستودع.",
    "inventory.action.add_item_store": "إضافة مستودعات",
    "inventory.action.remove_item_store": "إزالة هذا المستودع",
    "inventory.field.store_ids": "المستودعات",
    "inventory.item.tab.stores": "المستودعات",
    "inventory.refusal.store_not_allowed": "هذا الصنف لا يُحفظ في هذا المستودع؛ أضف المستودع إلى الصنف أولًا.",
    "inventory.refusal.store_ids_required": "اختر مستودعًا واحدًا على الأقل.",
    "inventory.refusal.held_elsewhere": "المستودعات التي تحفظ هذا الصنف الآن يجب أن تكون في قائمته أيضًا.",
    "inventory.refusal.store_holds_item": "ما زال هذا المستودع يحفظ الصنف؛ أخرجه أولًا.",
    "inventory.refusal.store_not_listed": "هذا المستودع ليس في قائمة الصنف.",
    "change.field.item.added_by": "أضافه",
    "inventory.item_reorder.title": "حدود إعادة الطلب",
    "inventory.item_reorder.note": "إذا نزل المخزون عن الحد يُنبَّه مرة واحدة، ولا يُنبَّه ثانية حتى يعود إلى الحد أو يتجاوزه.",
    "inventory.item_reorder.empty": "لم يُحدَّد حد لإعادة الطلب.",
    "inventory.item.tab.reorder": "إعادة الطلب",
    "inventory.col.min_quantity": "حد إعادة الطلب",
    "inventory.col.reorder_quantity": "كمية الطلب",
    "inventory.col.below": "تحت الحد",
    "inventory.below.true": "تحت الحد",
    "inventory.below.false": "عند الحد أو فوقه",
    "inventory.col.shortfall": "العجز",
    "inventory.col.alerted_at": "نُبِّه في",
    "inventory.col.below_reorder": "تحت حد إعادة الطلب",
    "inventory.action.set_reorder": "تحديد حد",
    "inventory.action.remove_reorder": "إزالة هذا الحد",
    "inventory.field.min_quantity": "حد إعادة الطلب",
    "inventory.field.min_quantity.help": "بوحدة الصنف نفسها.",
    "inventory.field.reorder_quantity": "الكمية المطلوب طلبها",
    "inventory.reorder.title": "تحت حد إعادة الطلب",
    "inventory.reorder.lede": "كل صنف ومستودع يحفظ أقل من حد إعادة الطلب، الأكبر عجزًا أولًا.",
    "inventory.reorder.empty": "كل مستودع يحفظ حد إعادة الطلب على الأقل.",
    "inventory.stat.run_out": "نفد",
    "inventory.stat.below_reorder": "تحت حد إعادة الطلب",
    "nav.inventory.reorder": "تحت حد إعادة الطلب",
    "inventory.refusal.min_quantity": "حد إعادة الطلب كمية صفر فأكثر، بثلاث خانات عشرية على الأكثر.",
    "inventory.refusal.reorder_quantity": "الكمية المطلوب طلبها أكبر من الصفر.",
    "inventory.refusal.no_reorder_level": "لا حد لإعادة الطلب في هذا المستودع.",
    "change.field.item.min_quantity": "حد إعادة الطلب",
    "change.field.item.reorder_quantity": "الكمية المطلوب طلبها",
    "inventory.col.minimum_quantity": "الحد الأدنى",
    "inventory.col.below_minimum": "تحت الحد الأدنى",
    "inventory.mark.below_minimum": "تحت الحد الأدنى",
    "inventory.stat.below_minimum": "تحت الحد الأدنى",
    "inventory.field.minimum_quantity": "الحد الأدنى",
    "inventory.field.minimum_quantity.help": "اختياري: أقل ما يجب أن يحتفظ به المستودع، ولا يزيد على حد إعادة الطلب.",
    "inventory.refusal.minimum_quantity": "الحد الأدنى كمية صفر فأكثر، بثلاث خانات عشرية على الأكثر.",
    "inventory.refusal.minimum_above_reorder": "لا يزيد الحد الأدنى على حد إعادة الطلب.",
    "change.field.item.minimum_quantity": "الحد الأدنى",
    "change.field.item.updated_by": "غيّره",
    "inventory.costing.average": "المتوسط المتحرك",
    "inventory.costing.fifo": "الوارد أولًا يُصرف أولًا",
    "inventory.costing.specific": "التمييز المحدد",
    "inventory.field.costing_method": "طريقة التكلفة",
    "inventory.field.costing_method.help": "إن تُرك فارغًا: طريقة الفئة، وإلا المتوسط المتحرك.",
    "inventory.field.costing_method.edit_help": "لا تتغيّر إلا إذا لم يحفظ أي مستودع شيئًا من الصنف.",
    "inventory.field.category_costing.help": "الطريقة التي يُكلَّف بها الصنف الجديد في هذه الفئة إن لم تُحدَّد له.",
    "inventory.col.costing_method": "طريقة التكلفة",
    "inventory.field.layer_id": "الدفعة",
    "inventory.field.layer_id.help": "للصنف المكلَّف بالتمييز المحدد فقط: أي استلام يُصرف.",
    "inventory.refusal.costing_method": "طريقة التكلفة: المتوسط المتحرك، أو الوارد أولًا، أو التمييز المحدد.",
    "inventory.refusal.costing_fixed": "مخزون هذا الصنف محفوظ؛ فلا تتغيّر طريقة تكلفته إلا إذا لم يحفظ أي مستودع شيئًا منه.",
    "inventory.refusal.layer_required": "هذا الصنف مكلَّف بالتمييز المحدد: حدّد الدفعة التي تُصرف.",
    "inventory.refusal.layer_not_found": "لا توجد هذه الدفعة لهذا الصنف في هذا المستودع.",
    "inventory.refusal.layer_not_specific": "تُحدَّد الدفعة فقط للصنف المكلَّف بالتمييز المحدد.",
    "inventory.refusal.layer_id": "تُحدَّد الدفعة بمعرّفها.",
    "change.field.item.costing_method": "طريقة التكلفة",
    "change.field.category.costing_method": "طريقة التكلفة",
    "inventory.field.tracks_lots": "يُتتبَّع بالدُّفعات",
    "inventory.field.tracks_lots.help": "كل استلام يذكر رقم الدفعة وتاريخ انتهائها، وكل صرف يذكر الدفعة التي يُصرف منها.",
    "inventory.field.lot_no": "رقم الدفعة",
    "inventory.field.lot_no.help": "مطلوب للصنف المتتبَّع بالدفعات؛ الرقم نفسه مرة أخرى يُضاف إلى تلك الدفعة.",
    "inventory.field.expires_on": "تاريخ الانتهاء",
    "inventory.field.lot_id": "الدفعة",
    "inventory.field.lot_id.help": "مطلوب للصنف المتتبَّع بالدفعات؛ الأقرب انتهاءً أولًا.",
    "inventory.field.allow_expired_issue": "صرف الدفعات المنتهية",
    "inventory.field.allow_expired_issue.help": "معطَّل افتراضيًا: الدفعة المنتهية تُشطب بتسوية ولا تُصرف.",
    "inventory.field.expiry_warning_days": "التنبيه قبل (أيام)",
    "inventory.field.expiry_warning_days.help": "من 0 إلى 365؛ 30 افتراضيًا.",
    "inventory.col.lot_no": "الدفعة",
    "inventory.col.lot_id": "معرّف الدفعة",
    "inventory.col.expires_on": "تاريخ الانتهاء",
    "inventory.col.days_left": "الأيام المتبقية",
    "inventory.col.expiry_state": "الصلاحية",
    "inventory.col.allow_expired_issue": "صرف الدفعات المنتهية",
    "inventory.col.expiry_warning_days": "التنبيه قبل (أيام)",
    "inventory.expiry_state.expired": "منتهية",
    "inventory.expiry_state.expiring": "تنتهي قريبًا",
    "inventory.expiry_state.fresh": "صالحة",
    "inventory.expiry_state.none": "بلا انتهاء",
    "inventory.stat.expired": "منتهية",
    "inventory.stat.expiring": "تنتهي قريبًا",
    "inventory.lots_expiring.title": "الدفعات قريبة الانتهاء",
    "inventory.lots_expiring.lede": "الدفعات المخزّنة المنتهية أو التي تنتهي خلال أيام التنبيه، الأقرب أولًا.",
    "inventory.lots_expiring.empty": "لا دفعة مخزّنة تنتهي خلال أيام التنبيه.",
    "inventory.item_lots.title": "الدفعات",
    "inventory.item_lots.note": "ما تبقّى في كل دفعة، الأقرب انتهاءً أولًا. الدفعة المنتهية لا تُصرف إلا إذا سمحت إعدادات المخزون بذلك.",
    "inventory.item_lots.empty": "لا توجد دفعة مخزّنة من هذا الصنف.",
    "inventory.item.tab.lots": "الدفعات",
    "inventory.settings.title": "إعدادات المخزون",
    "inventory.settings.section.stock": "الدفعات والجرد",
    "inventory.settings.section.stock.lede": "هل تُصرف الدفعة المنتهية، وكم يوماً قبل الانتهاء تنبّه قائمة المنتهي قريباً، وبماذا يبدأ عجز الجرد.",
    "inventory.settings.section.transfers": "التحويلات",
    "inventory.settings.section.transfers.lede": "القيمة التي ينتظر فوقها التحويل اعتماداً، وما يجوز أن يكون قيد النقل لكل مستودع.",
    "inventory.settings.lede": "هل تُصرف الدفعة المنتهية، وكم يومًا مسبقًا تنبّه قائمة الدفعات قريبة الانتهاء.",
    "inventory.settings.action.edit": "تعديل",
    "inventory.yes_no.true": "نعم",
    "inventory.yes_no.false": "لا",
    "nav.inventory.lots_expiring": "الدفعات قريبة الانتهاء",
    "nav.inventory.settings": "إعدادات المخزون",
    "change.field.item.tracks_lots": "يُتتبَّع بالدفعات",
    "change.field.item.lot_id": "الدفعة",
    "change.field.item.lot_no": "رقم الدفعة",
    "change.field.item.expires_on": "تاريخ الانتهاء",
    "change.field.item.supplier_party_id": "المورّد",
    "change.field.inventory_settings.allow_expired_issue": "صرف الدفعات المنتهية",
    "change.field.inventory_settings.expiry_warning_days": "التنبيه قبل (أيام)",
    "inventory.refusal.lot_short": "هذه الدفعة لا تحوي هذه الكمية هنا؛ اصرف الباقي من دفعة أخرى.",
    "inventory.refusal.lots_fixed": "يوجد مخزون من هذا الصنف؛ لا يتغيّر تتبّعه بالدفعات إلا إذا لم يبقَ منه شيء في أي مستودع.",
    "inventory.refusal.lot_not_tracked": "هذا الصنف لا يُتتبَّع بالدفعات؛ لا تذكر دفعة.",
    "inventory.refusal.lot_no_required": "هذا الصنف يُتتبَّع بالدفعات: أدخل رقم الدفعة.",
    "inventory.refusal.lot_expiry_mismatch": "استُلمت هذه الدفعة من قبل بتاريخ انتهاء آخر.",
    "inventory.refusal.lot_required": "هذا الصنف يُتتبَّع بالدفعات: اختر الدفعة التي يُصرف منها.",
    "inventory.refusal.lot_not_found": "لا توجد دفعة كهذه لهذا الصنف.",
    "inventory.refusal.lot_expired": "انتهت صلاحية هذه الدفعة؛ لا تُصرف (اشطبها بتسوية).",
    "inventory.refusal.lot_no_on_decrease": "الكمية المخرَجة تذكر الدفعة التي تخرج منها، لا رقم دفعة جديدًا.",
    "inventory.refusal.not_flag": "القيمة نعم أو لا.",
    "inventory.refusal.expires_on": "تاريخ الانتهاء يوم من التقويم.",
    "inventory.field.manufactured_on": "تاريخ الإنتاج",
    "inventory.col.manufactured_on": "تاريخ الإنتاج",
    "change.field.item.manufactured_on": "تاريخ الإنتاج",
    "inventory.refusal.manufactured_on": "تاريخ الإنتاج يوم من التقويم.",
    "inventory.refusal.manufactured_after_expiry": "تُنتَج الدفعة في يوم انتهائها أو قبله.",
    "inventory.refusal.manufactured_in_future": "لا يكون تاريخ إنتاج الدفعة بعد اليوم.",
    "inventory.refusal.lot_manufactured_mismatch": "استُلمت هذه الدفعة من قبل بتاريخ إنتاج آخر.",
    "inventory.refusal.lot_no": "رقم الدفعة حروف وأرقام و . _ / - حتى 60 خانة.",
    "inventory.refusal.lot_id": "اختر دفعة من القائمة.",
    "inventory.refusal.expiry_warning_days": "أدخل عددًا صحيحًا من الأيام بين 0 و365.",
    "inventory.field.store_kind": "النوع",
    "inventory.field.store_kind.help": "مستودع العبور يحوي فقط ما تحمله التحويلات في طريقها.",
    "inventory.col.store_kind": "النوع",
    "inventory.store_kind.regular": "مستودع عادي",
    "inventory.store_kind.transit": "مستودع عبور",
    "inventory.field.pending_cap": "سقف ما في العبور",
    "inventory.field.pending_cap.help": "أقصى قيمة يمكن أن تكون في العبور من هذا المستودع في آنٍ واحد؛ فارغ: سقف مساحة العمل.",
    "inventory.col.transfer_approval_above": "اعتماد التحويلات فوق",
    "inventory.col.transfer_pending_cap": "سقف العبور لكل مستودع",
    "inventory.field.transfer_approval_above": "اعتماد التحويلات فوق",
    "inventory.field.transfer_approval_above.help": "فارغ: لا ينتظر أي تحويل اعتمادًا.",
    "inventory.field.transfer_pending_cap": "سقف العبور لكل مستودع",
    "inventory.field.transfer_pending_cap.help": "فارغ: بلا سقف؛ سقف المستودع نفسه يُقدَّم.",
    "inventory.kind.transfer_out": "تحويل صادر",
    "inventory.kind.transfer_in": "تحويل وارد",
    "change.field.store.kind": "النوع",
    "change.field.store.pending_cap": "سقف ما في العبور",
    "change.field.store.number": "رقم التحويل",
    "change.field.store.from_store_id": "من مستودع",
    "change.field.store.to_store_id": "إلى مستودع",
    "change.field.store.via_store_id": "عبر مستودع العبور",
    "change.field.store.note": "ملاحظة",
    "change.field.store.sent_value": "القيمة المرسلة",
    "change.field.store.received_value": "القيمة المستلمة",
    "change.field.store.approved_at": "وقت الاعتماد",
    "change.field.store.approved_by": "اعتمده",
    "change.field.store.sent_at": "وقت الإرسال",
    "change.field.store.sent_by": "أرسله",
    "change.field.store.received_at": "وقت الاستلام",
    "change.field.store.received_by": "استلمه",
    "change.field.store.cancelled_at": "وقت الإلغاء",
    "change.field.store.cancelled_by": "ألغاه",
    "change.field.item.received_quantity": "الكمية المستلمة",
    "change.field.item.discrepancy_quantity": "الفرق",
    "change.field.item.discrepancy_note": "ملاحظة الفرق",
    "change.field.inventory_settings.transfer_approval_above": "اعتماد التحويلات فوق",
    "change.field.inventory_settings.transfer_pending_cap": "سقف العبور لكل مستودع",
    "inventory.refusal.store_kind_fixed": "هذا المستودع يحوي مخزونًا؛ لا يتغيّر كونه مستودع عبور إلا وهو فارغ.",
    "inventory.refusal.transit_store": "مستودع العبور لا يُحرَّك مخزونه إلا بالتحويلات.",
    "inventory.refusal.transfer_move": "حركة التحويل لا تُعكس وحدها؛ التحويل هو المستند.",
    "inventory.refusal.transfer_not_found": "لا يوجد تحويل كهذا في مساحة العمل.",
    "inventory.refusal.transfer_status": "حالة هذا التحويل لا تسمح بذلك.",
    "inventory.refusal.own_transfer": "يعتمد التحويل شخص غير منشئه.",
    "inventory.refusal.pending_cap": "ما في العبور من هذا المستودع سيتجاوز سقفه.",
    "inventory.refusal.over_receipt": "وصل أكثر مما أُرسل؛ استلم ما أُرسل وسجّل الباقي على حدة.",
    "inventory.refusal.via_not_transit": "المستودع الذي يمر به التحويل يجب أن يكون مستودع عبور.",
    "inventory.refusal.same_store": "التحويل يكون إلى مستودع آخر.",
    "inventory.refusal.via_store": "مستودع العبور ليس المصدر ولا الوجهة.",
    "inventory.refusal.lines_required": "يذكر التحويل سطرًا واحدًا على الأقل.",
    "inventory.refusal.line": "السطر صنف وكمية.",
    "inventory.refusal.line_no": "لا يوجد سطر كهذا في التحويل.",
    "inventory.refusal.received_quantity": "ما وصل كمية، صفر أو أكثر.",
    "inventory.refusal.from_store_id": "اختر المستودع المرسِل.",
    "inventory.refusal.to_store_id": "اختر المستودع المستلِم.",
    "inventory.refusal.via_store_id": "اختر مستودع عبور.",
    "inventory.refusal.from_store_id_required": "اختر المستودع المرسِل.",
    "inventory.refusal.to_store_id_required": "اختر المستودع المستلِم.",
    "inventory.col.count_shortage_default": "عجز الجرد",
    "inventory.field.count_shortage_default": "عجز الجرد",
    "inventory.field.count_shortage_default.help": "ما يبدأ به العجز الذي يكشفه الجرد؛ التحميل يذكر الجهة قبل الاعتماد.",
    "inventory.disposition.loss": "خسارة",
    "inventory.disposition.charge": "تحميل على جهة",
    "inventory.store_counts.title": "الجرد",
    "inventory.store_counts.note": "كل عمليات جرد هذا المستودع، الأحدث أولًا. أثناء الجرد يُجمَّد المستودع.",
    "inventory.store_counts.empty": "لم يُجرد هذا المستودع بعد.",
    "inventory.store.tab.counts": "الجرد",
    "inventory.col.count_code": "الجرد",
    "inventory.col.count_scope": "النطاق",
    "inventory.count_scope.full": "المستودع كاملًا",
    "inventory.count_scope.partial": "فئات محددة",
    "inventory.count_status.counting": "قيد العد",
    "inventory.count_status.submitted": "مُرسَل",
    "inventory.count_status.approved": "معتمد",
    "inventory.count_status.posted": "مُرحَّل",
    "inventory.count_status.cancelled": "ملغى",
    "inventory.col.shortage_value": "العجز",
    "inventory.col.surplus_value": "الزيادة",
    "inventory.col.opened_at": "فُتح",
    "change.field.inventory_settings.count_shortage_default": "عجز الجرد",
    "change.field.store.scope": "نطاق الجرد",
    "change.field.store.blind": "جرد أعمى",
    "change.field.store.shortage_value": "العجز",
    "change.field.store.surplus_value": "الزيادة",
    "change.field.store.submitted_at": "وقت الإرسال للمراجعة",
    "change.field.store.submitted_by": "أرسله للمراجعة",
    "change.field.store.posted_at": "وقت الترحيل",
    "change.field.store.posted_by": "رحّله",
    "change.field.store.store_id": "المستودع",
    "change.field.item.counted_quantity": "المعدود",
    "change.field.item.counted_by": "عدّه",
    "change.field.item.variance_quantity": "الفرق",
    "change.field.item.variance_value": "قيمة الفرق",
    "change.field.item.disposition": "التسوية",
    "inventory.refusal.store_frozen": "المستودع قيد الجرد؛ لا حركة دخولًا أو خروجًا حتى يُرحَّل الجرد أو يُلغى.",
    "inventory.refusal.count_not_found": "لا يوجد جرد كهذا في مساحة العمل.",
    "inventory.refusal.count_status": "الجرد ليس في هذه الخطوة.",
    "inventory.refusal.uncounted": "بعض الأسطر لم تُعد بعد.",
    "inventory.refusal.not_shortage": "لا يُسوّى إلا العجز.",
    "inventory.refusal.disposition_required": "سوِّ كل عجز أولًا: خسارة أو تحميل على جهة.",
    "inventory.refusal.party_required": "العجز المحمَّل يذكر الجهة المحمَّل عليها.",
    "inventory.refusal.counted_quantity": "المعدود كمية، صفر أو أكثر.",
    "inventory.refusal.category_ids": "اختر الفئات من القائمة.",
    "inventory.refusal.disposition": "العجز خسارة أو تحميل على جهة.",
    "inventory.refusal.count_shortage_default": "يبدأ العجز خسارةً أو تحميلًا.",
    "inventory.settings.action.edit_transfers": "التحويلات",
    "inventory.col.category_name_ar": "الفئة",
    "inventory.col.oldest_days": "الأقدم (أيام)",
    "inventory.col.d0_30": "0–30 يومًا",
    "inventory.col.d31_90": "31–90 يومًا",
    "inventory.col.d91_180": "91–180 يومًا",
    "inventory.col.d180_plus": "أكثر من 180 يومًا",
    "inventory.col.month": "الشهر",
    "inventory.stat.stale": "محتفظ به أكثر من 180 يومًا",
    "inventory.aging.title": "أعمار المخزون",
    "inventory.aging.lede": "ما يحويه كل مستودع من كل صنف بحسب مدة بقائه، من طبقات التكلفة؛ الإجماليات على كامل التصفية.",
    "inventory.aging.empty": "لا يوجد مخزون.",
    "inventory.consumption.title": "الاستهلاك",
    "inventory.consumption.lede": "ما صُرف بعد خصم المرتجعات، لكل شهر ومستودع وصنف والمستند الذي صُرف له؛ صفِّ بالمستند أو الصنف أو الفئة أو الأشهر وتتبعها الإجماليات.",
    "inventory.consumption.empty": "لم يُستهلك شيء في هذه الفترة.",
    "nav.inventory.aging": "أعمار المخزون",
    "nav.inventory.consumption": "الاستهلاك",
    "inventory.refusal.group": "التجميع بالمستند أو الصنف أو الفئة.",
    "inventory.refusal.period": "الفترة بأيام التقويم، وتنتهي في يوم بدئها أو بعده.",
    "nav.inventory.transfers": "التحويلات",
    "screen.inventory.transfers.title": "التحويلات",
    "screen.inventory.transfer.title": "تحويل",
    "entity.inventory.transfer": "تحويل",
    "inventory.transfers.title": "التحويلات",
    "inventory.transfers.lede": "المخزون المنقول بين المستودعات، مباشرةً أو عبر مستودع عبور، من المسودة حتى الاستلام.",
    "inventory.transfers.empty": "لا توجد تحويلات بعد.",
    "inventory.transfer.title": "تحويل",
    "inventory.transfer.monogram": "تح",
    "inventory.transfer.direct": "مباشر",
    "inventory.transfer_status.draft": "مسودة",
    "inventory.transfer_status.awaiting_approval": "بانتظار الاعتماد",
    "inventory.transfer_status.in_transit": "في الطريق",
    "inventory.transfer_status.received": "مستلم",
    "inventory.transfer_status.cancelled": "ملغى",
    "inventory.stat.in_transit_value": "القيمة في الطريق",
    "inventory.col.transfer": "التحويل",
    "inventory.col.transfer_code": "الرقم",
    "inventory.col.from_store": "من",
    "inventory.col.to_store": "إلى",
    "inventory.col.via_store": "عبر",
    "inventory.col.from_store_id": "معرّف المستودع المرسِل",
    "inventory.col.to_store_id": "معرّف المستودع المستلِم",
    "inventory.col.via_store_id": "معرّف مستودع العبور",
    "inventory.col.via": "عبر مستودع عبور",
    "inventory.col.line_count": "الأسطر",
    "inventory.col.sent_value": "القيمة المرسلة",
    "inventory.col.received_value": "القيمة المستلمة",
    "inventory.col.sent_at": "أُرسل",
    "inventory.col.received_at": "استُلم",
    "inventory.col.approved_at": "اعتُمد",
    "inventory.col.drafted_at": "أُنشئ",
    "inventory.col.updated_at": "آخر تغيير",
    "inventory.col.drafted_by": "أنشأه",
    "inventory.col.sent_by": "أرسله",
    "inventory.col.approved_by": "اعتمده",
    "inventory.col.received_by": "استلمه",
    "inventory.col.created_by": "معرّف المنشئ",
    "inventory.col.sent_by_id": "معرّف المرسِل",
    "inventory.col.approved_by_id": "معرّف المعتمِد",
    "inventory.col.received_by_id": "معرّف المستلِم",
    "inventory.col.quantity_sent": "المرسل",
    "inventory.col.received_quantity": "المستلم",
    "inventory.col.discrepancy_quantity": "الفرق",
    "inventory.col.discrepancy_note": "ملاحظة الفرق",
    "inventory.col.can_send": "يمكن إرساله",
    "inventory.col.can_approve": "يمكن اعتماده",
    "inventory.col.can_receive": "يمكن استلامه",
    "inventory.col.can_cancel": "يمكن إلغاؤه",
    "inventory.col.ref_token": "مرجع المستند",
    "inventory.field.from_store_id": "المستودع المرسِل",
    "inventory.field.to_store_id": "المستودع المستلِم",
    "inventory.field.via_store_id": "مستودع العبور",
    "inventory.field.via_store_id.help": "اتركه فارغًا للتحويل المباشر",
    "inventory.field.transfer_lines": "الأسطر",
    "inventory.transfer.action.create": "تحويل جديد",
    "inventory.transfer.action.create.effect": "الصنف المتتبَّع بالدفعات يخرج من أقرب دفعاته انتهاءً أولًا.",
    "inventory.transfer.action.send": "إرسال",
    "inventory.transfer.action.send.effect": "يخرج المخزون من المستودع المرسِل الآن؛ وما زادت قيمته عن حد الاعتماد ينتظر الاعتماد أولًا.",
    "inventory.transfer.action.approve": "اعتماد وإرسال",
    "inventory.transfer.action.approve.effect": "يخرج المخزون من المستودع المرسِل فور اعتماده.",
    "inventory.transfer.action.receive": "تأكيد الاستلام",
    "inventory.transfer.action.cancel": "إلغاء",
    "inventory.transfer.action.cancel.effect": "لم يتحرك شيء بعد؛ ويبقى التحويل في السجل ملغى.",
    "inventory.transfer.alert.awaiting_other": "بانتظار اعتماد شخص آخر",
    "inventory.transfer.alert.approve": "قيمته فوق حد الاعتماد: اعتمده ليُرسَل",
    "inventory.transfer.alert.in_transit": "في الطريق عبر مستودع العبور: يؤكد المستودع المستلِم ما وصل",
    "inventory.transfer.tab.lines": "الأسطر",
    "inventory.transfer.tab.details": "التفاصيل",
    "inventory.transfer.lines.note": "ما لم يصل فرقٌ على السطر يُشطب من مستودع العبور.",
    "inventory.store.tab.transfers": "التحويلات",
    "inventory.store_transfers.title": "التحويلات",
    "inventory.store_transfers.note": "الوارد إلى هذا المستودع والصادر منه؛ ما ينتظر الاعتماد أو في الطريق أولًا.",
    "inventory.store_transfers.empty": "لم يُحوَّل مخزون إلى هذا المستودع أو منه بعد.",
    "inventory.receive.title": "تأكيد استلام {code}",
    "inventory.receive.lede": "ما وصل سطرًا سطرًا؛ كل سطر وصل كاملًا ما لم تذكر أقل.",
    "inventory.receive.notice": "ما لم يصل يُسجَّل فرقًا ويُشطب من مستودع العبور.",
    "inventory.receive.note_required": "اذكر سبب وصول أقل مما أُرسل.",
    "inventory.receive.short": "{n} من الأسطر وصلت ناقصة؛ ويُشطب فرقها من مستودع العبور.",
    "inventory.receive.saved": "تم تأكيد الاستلام",
    "inventory.receive.no_row": "افتح هذا من تحويل.",
    "inventory.receive.not_in_transit": "هذا التحويل لم يعد في الطريق.",
    "inventory.refusal.store_kind": "المستودع عادي أو مستودع عبور.",
    "nav.inventory.counts": "جرد المخزون",
    "inventory.counts.title": "جرد المخزون",
    "inventory.counts.lede": "عدّ مستودع وتسوية فروقه وترحيلها تسويات مخزون؛ يُجمَّد المستودع ما دام الجرد مفتوحًا.",
    "inventory.counts.empty": "لم يُجرَد أي مستودع بعد.",
    "inventory.stat.open_counts": "جرد مفتوح",
    "inventory.col.blind": "جرد أعمى",
    "inventory.col.can_count": "يمكن عدّه",
    "inventory.col.can_submit": "يمكن إرساله",
    "inventory.col.can_post": "يمكن ترحيله",
    "inventory.col.can_settle": "يمكن تسويته",
    "inventory.col.cancelled_at": "أُلغي",
    "inventory.col.cancelled_by": "ألغاه",
    "inventory.col.cancelled_by_id": "معرّف من ألغاه",
    "inventory.col.count": "الجرد",
    "inventory.col.count_id": "معرّف الجرد",
    "inventory.col.count_party": "الجهة",
    "inventory.col.counted_at": "وقت العدّ",
    "inventory.col.counted_by": "عدّه",
    "inventory.col.counted_by_id": "معرّف من عدّه",
    "inventory.col.counted_count": "المعدود",
    "inventory.col.counted_quantity": "المعدود",
    "inventory.col.expected_quantity": "المتوقع",
    "inventory.col.disposition": "التسوية",
    "inventory.col.is_shortage": "عجز",
    "inventory.col.line_no": "السطر",
    "inventory.col.opened_by": "فتحه",
    "inventory.col.opened_by_id": "معرّف من فتحه",
    "inventory.col.posted_by": "رحّله",
    "inventory.col.posted_by_id": "معرّف من رحّله",
    "inventory.col.submitted_at": "أُرسل",
    "inventory.col.submitted_by": "أرسله",
    "inventory.col.submitted_by_id": "معرّف من أرسله",
    "inventory.col.variance_kind": "نوع الفرق",
    "inventory.col.variance_quantity": "الفرق",
    "inventory.col.variance_value": "قيمة الفرق",
    "inventory.variance_kind.shortage": "عجز",
    "inventory.variance_kind.surplus": "زيادة",
    "inventory.variance_kind.none": "مطابق",
    "inventory.count.title": "الجرد",
    "inventory.count.blind_mark": "أعمى",
    "inventory.count.monogram": "جر",
    "inventory.count.tab.lines": "الأسطر",
    "inventory.count.tab.details": "التفاصيل",
    "inventory.count.action.create": "فتح جرد",
    "inventory.count.action.count": "عدّ",
    "inventory.count.action.submit": "إرسال للمراجعة",
    "inventory.count.action.submit.effect": "يُرفض ما دام سطر لم يُعدّ، وتظهر الفروق بعد الإرسال.",
    "inventory.count.action.approve": "اعتماد",
    "inventory.count.action.approve.effect": "يُرفض ما دام عجز لم يُسوَّ خسارةً أو تحميلًا على جهة.",
    "inventory.count.action.post": "ترحيل",
    "inventory.count.action.post.effect": "يصير كل فرق تسوية مخزون، ويُرسَل العجز المحمَّل لاسترداده، ويُفكّ تجميد المستودع.",
    "inventory.count.action.cancel": "إلغاء",
    "inventory.count.action.cancel.effect": "لا تُسوّى أي كمية؛ يُفكّ تجميد المستودع ويبقى الجرد في السجل ملغى.",
    "inventory.count.action.settle": "تسوية",
    "inventory.count.alert.counting": "قيد العدّ: المستودع مجمَّد حتى يُرحَّل الجرد أو يُلغى",
    "inventory.count.alert.settle": "سوِّ كل عجز في الأسطر خسارةً أو تحميلًا على جهة، ثم اعتمد",
    "inventory.count.alert.post": "معتمد: رحّله لتسوية المخزون وفكّ تجميد المستودع",
    "inventory.count_lines.title": "الأسطر",
    "inventory.count_lines.note": "يُظهر الجرد الأعمى الكمية المتوقعة بعد إرساله، ويُسوّى كل عجز قبل اعتماد الجرد.",
    "inventory.count_lines.empty": "لا أسطر في هذا الجرد: لم يكن في المستودع شيء ضمن نطاقه.",
    "inventory.field.count_store_id.help": "فتح الجرد يجمّد المستودع: لا استلام ولا صرف ولا تحويل حتى يُرحَّل أو يُلغى.",
    "inventory.field.category_ids": "الفئات",
    "inventory.field.category_ids.help": "فارغة: المستودع كاملًا. تشمل الفئة ما تحتها.",
    "inventory.field.blind": "جرد أعمى",
    "inventory.field.blind.help": "يُخفي الكمية المتوقعة عن العادّين حتى الإرسال.",
    "inventory.field.count_party.help": "الجهة التي يُسترد منها العجز عند ترحيل الجرد.",
    "inventory.counting.screen": "العدّ",
    "inventory.counting.lede": "كل سطر من جرد مفتوح يُعدّ ويُحفظ، ثم يُرسل للمراجعة.",
    "inventory.counting.title": "عدّ {code}",
    "inventory.counting.no_id": "افتح هذه الصفحة من جرد.",
    "inventory.counting.closed": "لم يعد هذا الجرد قيد العدّ.",
    "inventory.counting.closed.detail": "أُرسل أو رُحّل أو أُلغي؛ يُظهر سجله ما وُجد.",
    "inventory.counting.empty": "لا شيء للعدّ.",
    "inventory.counting.empty.detail": "لم يكن في المستودع شيء ضمن نطاق هذا الجرد عند فتحه.",
    "inventory.counting.blind": "جرد أعمى: الكمية المتوقعة مخفية حتى الإرسال.",
    "inventory.counting.progress": "عُدّ {n} من {of}",
    "inventory.counting.next": "السطر التالي",
    "inventory.counting.save_next": "حفظ والتالي",
    "inventory.counting.all_counted": "عُدّت كل الأسطر: أرسل الجرد للمراجعة.",
    "inventory.counting.lines": "كل الأسطر",
    "inventory.counting.lines.detail": "صحّح أي عدّ هنا؛ يُعتمد آخر إدخال.",
    "inventory.counting.save": "حفظ التعديلات ({n})",
    "inventory.counting.saved": "حُفظ.",
    "inventory.counting.submitted": "أُرسل للمراجعة.",
    "inventory.counting.left": "بقي {n} من الأسطر لم يُعدّ.",
    // صفحة العضو: المستودعات التي يعمل فيها (pm core-qkg4b5kj).
    "inventory.member_stores.title": "نطاق البيانات: المستودعات",
    "inventory.member_store_scope.title": "نطاق المستودعات",
    "inventory.col.store_scope": "المستودعات التي يراها",
    "inventory.store_scope.all": "كل المستودعات (بصلاحية)",
    "inventory.store_scope.listed": "مستودعات محددة فقط",
    "inventory.store_scope.none": "لا شيء — لا يرى أي مخزون",
    "inventory.member_stores.note": "يرى العضو المستودع ويحرّك مخزونه. ومن يملك صلاحية «يرى كل المستودعات» يراها كلها دون أن يكون عضوًا.",
    "inventory.member_stores.empty": "ليس عضوًا في أي مستودع تراه.",
    "inventory.action.add_stores": "إضافة إلى مستودعات",
    "inventory.refusal.member_not_found": "لا يوجد عضو بهذا المعرّف في مساحة العمل.",
};
//# sourceMappingURL=i18n-inventory.js.map